"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomAppExposureCapabilityDecisionSchema = exports.CustomAppEffectivePrincipalTypeSchema = exports.CustomAppCapabilitySchema = exports.CustomAppCapabilityPermissionSchema = exports.CustomAppPlatformCapabilityIdSchema = exports.CustomAppInternalLiveCommandRequestSchema = exports.CustomAppInternalLiveDatasetWindowResponseSchema = exports.CustomAppInternalLiveCellSchema = exports.CustomAppInternalLiveDatasetWindowRequestSchema = exports.CustomAppRuntimeModeSchema = exports.CustomAppExposureProfilePolicySchema = exports.CustomAppDeliverySchema = exports.CustomAppLiveDataPolicySchema = exports.CustomAppRouteCachePolicySchema = exports.CustomAppCacheClassSchema = exports.CustomAppCacheProfileSchema = exports.CustomAppDeliveryModeSchema = exports.CustomAppBlockCapabilityClassSchema = exports.CustomAppKindSchema = exports.CustomAppExposureProfileSchema = exports.CustomAppAccessModeSchema = exports.CustomAppDatabaseBindingAudienceSchema = exports.CustomAppProductModeSchema = exports.CUSTOM_APP_WORKSPACE_DATASET_INVALIDATED_EVENT = exports.CUSTOM_APP_INTERNAL_LIVE_COMMAND_ROUTE = exports.CUSTOM_APP_INTERNAL_LIVE_EVENTS_ROUTE = exports.CUSTOM_APP_INTERNAL_LIVE_DATA_ROUTE = exports.CUSTOM_APP_EXTERNAL_ACTION_ROUTE = exports.CUSTOM_APP_EXTERNAL_EVENTS_ROUTE = exports.CUSTOM_APP_EXTERNAL_DATA_ROUTE = exports.CUSTOM_APP_COMPOSITION_COMPILER_VERSION = exports.CUSTOM_APP_COMPILED_ARTIFACT_PROVENANCE_SCHEMA_VERSION = exports.CUSTOM_APP_COMPILED_ROUTE_SEO_SCHEMA_VERSION = exports.CUSTOM_APP_BLOCK_SEO_CONTRACT_SCHEMA_VERSION = exports.CUSTOM_APP_INVOCATION_REPLAY_SEMANTICS = exports.CustomAppInvocationRequestIdSchema = exports.CUSTOM_APP_INVOCATION_IDENTITY_CONTRACT_VERSION = exports.CUSTOM_APP_EXPOSURE_PROFILE_SCHEMA_VERSION = exports.CUSTOM_APP_AGENT_ACTION_DEFINITION_SCHEMA_VERSION = exports.CUSTOM_APP_BLOCK_DEFINITION_SCHEMA_VERSION = exports.CUSTOM_APP_APP_BLOCK_MOUNT_SCHEMA_VERSION = exports.CUSTOM_APP_COMPOSITION_SCHEMA_VERSION = exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION = exports.CUSTOM_APP_DOCUMENT_EXPORT_SCHEMA_VERSION = exports.CUSTOM_APP_ROUTE_MODULE_SCHEMA_VERSION = exports.CUSTOM_APP_INTERACTION_CONTRACT_SCHEMA_VERSION = exports.CUSTOM_APP_LIFECYCLE_SCHEMA_VERSION = exports.CUSTOM_APP_ARTIFACT_SCHEMA_VERSION = exports.CUSTOM_APP_DATABASE_BINDING_SCHEMA_VERSION = exports.CUSTOM_APP_MANIFEST_SCHEMA_VERSION = void 0;
exports.CustomAppBlockDefinitionOperationSchema = exports.CustomAppBlockDefinitionSchema = exports.CustomAppAppBlockRouteDefinitionSchema = exports.CustomAppAppBlockCompiledOutputSchema = exports.CustomAppAppBlockDefinitionOutputSchema = exports.CustomAppAppBlockResourceDefinitionSchema = exports.CustomAppRouteModuleSchema = exports.CustomAppArtifactFileSchema = exports.CustomAppCompiledArtifactProvenanceSchema = exports.CustomAppCompositionOperationBatchSchema = exports.CustomAppCompositionOperationSchema = exports.CustomAppCompositionSchema = exports.CustomAppAppBlockMountSchema = exports.CustomAppAppBlockBindingRefSchema = exports.CustomAppAppBlockNavigationPlacementSchema = exports.CustomAppAppBlockMountSlotSchema = exports.CustomAppCompositionShellSchema = exports.CustomAppManifestSchema = exports.CustomAppManifestBaseSchema = exports.CustomAppInteractionContractSchema = exports.CustomAppInteractionControlSchema = exports.CustomAppInteractionConfirmationPolicySchema = exports.CustomAppInteractionRequiredRoleSchema = exports.CustomAppInteractionIntentSchema = exports.CustomAppInteractionControlKindSchema = exports.CustomAppCompiledRouteSeoSchema = exports.CustomAppCompiledRouteSeoOwnerSchema = exports.CustomAppBlockSeoContractSchema = exports.CustomAppBlockSeoAiSearchSchema = exports.CustomAppBlockSeoHreflangSchema = exports.CustomAppBlockSeoCanonicalSchema = exports.CustomAppBlockSeoMetadataSourceSchema = exports.CustomAppBlockSeoStrategySchema = exports.CustomAppAgentActionDefinitionSchema = exports.CustomAppAgentActionResourceBindingSchema = exports.CustomAppBlockVisibilityContractSchema = exports.CustomAppDocumentExportSchema = exports.CustomAppDocumentExportFormatSchema = exports.CustomAppActionSchema = exports.CustomAppAttachmentUpdateActionSchema = exports.CustomAppAutomationRunActionSchema = exports.CustomAppAutomationResultPresentationSchema = exports.CustomAppAutomationInputBindingSchema = exports.CustomAppRowInsertActionSchema = exports.CustomAppActionFieldSchema = exports.CustomAppNavigationItemSchema = exports.CustomAppRouteSchema = exports.CustomAppBuildingBlockRefSchema = exports.CustomAppBuildingBlockKindSchema = exports.CustomAppInvocationIdentitySchema = void 0;
exports.CUSTOM_APP_BUDGETS = exports.CustomAppDatabaseBindingRegistrySchema = exports.CustomAppDatabaseBindingSchema = exports.CustomAppDatabaseBindingPlacementSchema = exports.CustomAppDatabaseBindingExposureSchema = exports.CustomAppDatabaseBindingDetachPolicySchema = exports.CustomAppDatabaseBindingStatusSchema = exports.CustomAppDatabaseBindingOwnershipSchema = exports.CustomAppLifecycleSchema = exports.CustomAppLifecycleBudgetCountersSchema = exports.CustomAppLifecycleOperationSchema = exports.CustomAppLifecycleRunStateSchema = exports.CustomAppLifecycleBriefSchema = exports.CustomAppBlockVisibilityCompatibilityIssueSchema = exports.CustomAppArtifactSchema = exports.CustomAppBlockDefinitionOperationBatchSchema = void 0;
exports.resolveCustomAppKindFromExposureProfile = resolveCustomAppKindFromExposureProfile;
exports.defaultCustomAppExposureProfileForKind = defaultCustomAppExposureProfileForKind;
exports.customAppCapabilityClassForExposureProfile = customAppCapabilityClassForExposureProfile;
exports.exposureProfileForCustomAppBlockCapabilityClass = exposureProfileForCustomAppBlockCapabilityClass;
exports.isCustomAppBlockCapabilityCompatible = isCustomAppBlockCapabilityCompatible;
exports.deriveCustomAppExposureProfile = deriveCustomAppExposureProfile;
exports.resolveCustomAppExposureProfileFromDeliveryMode = resolveCustomAppExposureProfileFromDeliveryMode;
exports.decideCustomAppExposureCapability = decideCustomAppExposureCapability;
exports.canonicalCustomAppInvocationIdentity = canonicalCustomAppInvocationIdentity;
exports.deriveCustomAppInvocationOperationId = deriveCustomAppInvocationOperationId;
exports.customAppCanonicalPayloadDigest = customAppCanonicalPayloadDigest;
exports.normalizeCustomAppInvocationRoute = normalizeCustomAppInvocationRoute;
exports.defineCustomAppBlock = defineCustomAppBlock;
exports.compileCustomAppBlockDefinition = compileCustomAppBlockDefinition;
exports.scopedAppBlockFilePath = scopedAppBlockFilePath;
exports.customAppSha256Hex = customAppSha256Hex;
exports.compileCustomAppBlockMount = compileCustomAppBlockMount;
exports.getCustomAppBlockVisibilityCompatibilityIssues = getCustomAppBlockVisibilityCompatibilityIssues;
exports.customAppCapabilityForAction = customAppCapabilityForAction;
exports.assertCustomAppBlockVisibilityCompatibility = assertCustomAppBlockVisibilityCompatibility;
exports.compileCustomAppComposition = compileCustomAppComposition;
exports.buildCustomAppInteractionContract = buildCustomAppInteractionContract;
exports.buildCustomAppCapabilityDeclarations = buildCustomAppCapabilityDeclarations;
exports.withCustomAppInteractionContract = withCustomAppInteractionContract;
exports.createCustomAppDatabaseBinding = createCustomAppDatabaseBinding;
exports.createCustomAppDatabaseSemanticKey = createCustomAppDatabaseSemanticKey;
exports.createCustomAppDatabaseSchemaFingerprint = createCustomAppDatabaseSchemaFingerprint;
exports.bumpCustomAppDatabaseBindingRevision = bumpCustomAppDatabaseBindingRevision;
const brand_1 = require("@streamlain/brand");
const zod_1 = require("zod");
exports.CUSTOM_APP_MANIFEST_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_DATABASE_BINDING_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_ARTIFACT_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_LIFECYCLE_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_INTERACTION_CONTRACT_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_ROUTE_MODULE_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_DOCUMENT_EXPORT_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_COMPOSITION_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_APP_BLOCK_MOUNT_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_BLOCK_DEFINITION_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_AGENT_ACTION_DEFINITION_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_EXPOSURE_PROFILE_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_INVOCATION_IDENTITY_CONTRACT_VERSION = 1;
exports.CustomAppInvocationRequestIdSchema = zod_1.z.string().uuid().max(64);
exports.CUSTOM_APP_INVOCATION_REPLAY_SEMANTICS = Object.freeze({
    invalidRequestStatus: 400,
    duplicateSameIdentity: 'replay',
    requestFingerprintConflictStatus: 409,
});
exports.CUSTOM_APP_BLOCK_SEO_CONTRACT_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_COMPILED_ROUTE_SEO_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_COMPILED_ARTIFACT_PROVENANCE_SCHEMA_VERSION = 1;
exports.CUSTOM_APP_COMPOSITION_COMPILER_VERSION = 'streamlain-custom-app-composition-compiler/v1';
exports.CUSTOM_APP_EXTERNAL_DATA_ROUTE = '/_custom-data';
exports.CUSTOM_APP_EXTERNAL_EVENTS_ROUTE = '/_custom-events';
exports.CUSTOM_APP_EXTERNAL_ACTION_ROUTE = '/_custom-action';
exports.CUSTOM_APP_INTERNAL_LIVE_DATA_ROUTE = '/_app-live/data';
exports.CUSTOM_APP_INTERNAL_LIVE_EVENTS_ROUTE = '/_app-live/events';
exports.CUSTOM_APP_INTERNAL_LIVE_COMMAND_ROUTE = '/_app-live/command';
exports.CUSTOM_APP_WORKSPACE_DATASET_INVALIDATED_EVENT = 'streamlain:custom-app-workspace-dataset-invalidated';
/**
 * Apps have one runtime product model. Knowledge Base is a Marketplace
 * App Block assembled from internal PagePresets, not a second App runtime.
 */
exports.CustomAppProductModeSchema = zod_1.z.literal('custom-app');
exports.CustomAppDatabaseBindingAudienceSchema = zod_1.z.enum([
    'public',
    'members',
    'internal',
    'portal',
]);
exports.CustomAppAccessModeSchema = zod_1.z.enum([
    'public',
    'members',
    'portal',
]);
exports.CustomAppExposureProfileSchema = zod_1.z.enum([
    'publicStatic',
    'publicInteractive',
    'memberPortal',
    'internalLive',
]);
/**
 * User-facing Custom App kinds.
 *
 * Exposure profiles remain an internal runtime detail: a Web App can mix
 * static, interactive and (when enabled) portal routes, while a Workspace App
 * is authenticated and may consume every App Block capability class.
 */
exports.CustomAppKindSchema = zod_1.z.enum(['web', 'workspace']);
exports.CustomAppBlockCapabilityClassSchema = zod_1.z.enum([
    'public-static',
    'public-interactive',
    'portal',
    'internal',
]);
function resolveCustomAppKindFromExposureProfile(profile) {
    return profile === 'internalLive' ? 'workspace' : 'web';
}
function defaultCustomAppExposureProfileForKind(kind) {
    return kind === 'workspace' ? 'internalLive' : 'publicStatic';
}
function customAppCapabilityClassForExposureProfile(profile) {
    switch (profile) {
        case 'publicStatic':
            return 'public-static';
        case 'publicInteractive':
            return 'public-interactive';
        case 'memberPortal':
            return 'portal';
        case 'internalLive':
            return 'internal';
    }
}
/** Canonical runtime delivery profile for an App Block capability class. */
function exposureProfileForCustomAppBlockCapabilityClass(capabilityClass) {
    switch (capabilityClass) {
        case 'public-static':
            return 'publicStatic';
        case 'public-interactive':
            return 'publicInteractive';
        case 'portal':
            return 'memberPortal';
        case 'internal':
            return 'internalLive';
    }
}
function isCustomAppBlockCapabilityCompatible(input) {
    if (input.appKind === 'workspace')
        return true;
    if (input.capabilityClass === 'internal')
        return false;
    if (input.capabilityClass === 'portal')
        return input.portalEnabled === true;
    return true;
}
exports.CustomAppDeliveryModeSchema = zod_1.z.enum([
    'public_static',
    'public_interactive',
    'member_portal',
    'internal_live',
]);
exports.CustomAppCacheProfileSchema = zod_1.z.enum([
    'public_static',
    'public_interactive',
    'member_portal',
    'internal_live',
]);
exports.CustomAppCacheClassSchema = zod_1.z.enum([
    'htmlShell',
    'staticAsset',
    'customData',
    'customEvents',
    'customAction',
    'internalLiveData',
    'internalLiveEvents',
    'internalLiveCommand',
    'automationStatus',
    'portal',
]);
exports.CustomAppRouteCachePolicySchema = zod_1.z
    .object({
    path: zod_1.z.string().min(1),
    cacheClass: exports.CustomAppCacheClassSchema.default('htmlShell'),
})
    .strict();
exports.CustomAppLiveDataPolicySchema = zod_1.z
    .object({
    enabled: zod_1.z.boolean().default(false),
    transport: zod_1.z.literal('sse').default('sse'),
    scope: zod_1.z
        .union([
        zod_1.z.enum(['none', 'dataset-invalidations', 'automation-status']),
        zod_1.z
            .array(zod_1.z.enum(['dataset-invalidations', 'automation-status']))
            .min(1)
            .max(2),
    ])
        .default('none'),
    publicLiveRequiresConfirmation: zod_1.z.boolean().default(true),
    statusExposure: zod_1.z.literal('summary').default('summary'),
})
    .strict();
exports.CustomAppDeliverySchema = zod_1.z
    .object({
    mode: exports.CustomAppDeliveryModeSchema.default('public_static'),
    cacheProfile: exports.CustomAppCacheProfileSchema.default('public_static'),
    routePolicies: zod_1.z.array(exports.CustomAppRouteCachePolicySchema).default([]),
    liveData: exports.CustomAppLiveDataPolicySchema.default({}),
})
    .strict();
exports.CustomAppExposureProfilePolicySchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_EXPOSURE_PROFILE_SCHEMA_VERSION),
    profile: exports.CustomAppExposureProfileSchema,
    access: exports.CustomAppAccessModeSchema,
    routeAudience: exports.CustomAppDatabaseBindingAudienceSchema,
    databaseBindingAudience: exports.CustomAppDatabaseBindingAudienceSchema,
    delivery: exports.CustomAppDeliverySchema,
    robotsIndex: zod_1.z.boolean(),
    requiresAuthenticatedViewer: zod_1.z.boolean(),
    allowsLiveData: zod_1.z.boolean(),
    allowsCommands: zod_1.z.boolean(),
    allowsWrites: zod_1.z.boolean(),
})
    .strict();
function deriveCustomAppExposureProfile(profile) {
    switch (profile) {
        case 'publicStatic':
            return exports.CustomAppExposureProfilePolicySchema.parse({
                schemaVersion: exports.CUSTOM_APP_EXPOSURE_PROFILE_SCHEMA_VERSION,
                profile,
                access: 'public',
                routeAudience: 'public',
                databaseBindingAudience: 'public',
                delivery: {
                    mode: 'public_static',
                    cacheProfile: 'public_static',
                    routePolicies: [],
                    liveData: {
                        enabled: false,
                        transport: 'sse',
                        scope: 'none',
                        publicLiveRequiresConfirmation: true,
                        statusExposure: 'summary',
                    },
                },
                robotsIndex: true,
                requiresAuthenticatedViewer: false,
                allowsLiveData: false,
                allowsCommands: false,
                allowsWrites: false,
            });
        case 'publicInteractive':
            return exports.CustomAppExposureProfilePolicySchema.parse({
                schemaVersion: exports.CUSTOM_APP_EXPOSURE_PROFILE_SCHEMA_VERSION,
                profile,
                access: 'public',
                routeAudience: 'public',
                databaseBindingAudience: 'public',
                delivery: {
                    mode: 'public_interactive',
                    cacheProfile: 'public_interactive',
                    routePolicies: [
                        { path: exports.CUSTOM_APP_EXTERNAL_DATA_ROUTE, cacheClass: 'customData' },
                        {
                            path: exports.CUSTOM_APP_EXTERNAL_EVENTS_ROUTE,
                            cacheClass: 'customEvents',
                        },
                        {
                            path: exports.CUSTOM_APP_EXTERNAL_ACTION_ROUTE,
                            cacheClass: 'customAction',
                        },
                    ],
                    liveData: {
                        enabled: true,
                        transport: 'sse',
                        scope: ['dataset-invalidations', 'automation-status'],
                        publicLiveRequiresConfirmation: true,
                        statusExposure: 'summary',
                    },
                },
                robotsIndex: true,
                requiresAuthenticatedViewer: false,
                allowsLiveData: true,
                allowsCommands: true,
                allowsWrites: true,
            });
        case 'memberPortal':
            return exports.CustomAppExposureProfilePolicySchema.parse({
                schemaVersion: exports.CUSTOM_APP_EXPOSURE_PROFILE_SCHEMA_VERSION,
                profile,
                access: 'portal',
                routeAudience: 'portal',
                databaseBindingAudience: 'portal',
                delivery: {
                    mode: 'member_portal',
                    cacheProfile: 'member_portal',
                    routePolicies: [
                        { path: exports.CUSTOM_APP_EXTERNAL_DATA_ROUTE, cacheClass: 'customData' },
                        {
                            path: exports.CUSTOM_APP_EXTERNAL_EVENTS_ROUTE,
                            cacheClass: 'customEvents',
                        },
                        {
                            path: exports.CUSTOM_APP_EXTERNAL_ACTION_ROUTE,
                            cacheClass: 'customAction',
                        },
                    ],
                    liveData: {
                        enabled: true,
                        transport: 'sse',
                        scope: ['dataset-invalidations', 'automation-status'],
                        publicLiveRequiresConfirmation: true,
                        statusExposure: 'summary',
                    },
                },
                robotsIndex: false,
                requiresAuthenticatedViewer: true,
                allowsLiveData: true,
                allowsCommands: true,
                allowsWrites: true,
            });
        case 'internalLive':
            return exports.CustomAppExposureProfilePolicySchema.parse({
                schemaVersion: exports.CUSTOM_APP_EXPOSURE_PROFILE_SCHEMA_VERSION,
                profile,
                access: 'members',
                routeAudience: 'internal',
                databaseBindingAudience: 'internal',
                delivery: {
                    mode: 'internal_live',
                    cacheProfile: 'internal_live',
                    routePolicies: [
                        {
                            path: exports.CUSTOM_APP_INTERNAL_LIVE_DATA_ROUTE,
                            cacheClass: 'internalLiveData',
                        },
                        {
                            path: exports.CUSTOM_APP_INTERNAL_LIVE_EVENTS_ROUTE,
                            cacheClass: 'internalLiveEvents',
                        },
                        {
                            path: exports.CUSTOM_APP_INTERNAL_LIVE_COMMAND_ROUTE,
                            cacheClass: 'internalLiveCommand',
                        },
                    ],
                    liveData: {
                        enabled: true,
                        transport: 'sse',
                        scope: ['dataset-invalidations', 'automation-status'],
                        publicLiveRequiresConfirmation: true,
                        statusExposure: 'summary',
                    },
                },
                robotsIndex: false,
                requiresAuthenticatedViewer: true,
                allowsLiveData: true,
                allowsCommands: true,
                allowsWrites: true,
            });
    }
}
function resolveCustomAppExposureProfileFromDeliveryMode(deliveryMode) {
    if (deliveryMode === 'internal_live')
        return 'internalLive';
    if (deliveryMode === 'member_portal')
        return 'memberPortal';
    if (deliveryMode === 'public_interactive')
        return 'publicInteractive';
    return 'publicStatic';
}
exports.CustomAppRuntimeModeSchema = zod_1.z.enum([
    'external_snapshot',
    'member_portal_snapshot',
    'internal_live',
]);
exports.CustomAppInternalLiveDatasetWindowRequestSchema = zod_1.z
    .object({
    appId: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    sourceKey: zod_1.z.string().min(1),
    cursor: zod_1.z.string().min(1).optional(),
    limit: zod_1.z.number().int().positive().max(5000),
    sort: zod_1.z
        .array(zod_1.z
        .object({
        columnId: zod_1.z.string().min(1),
        direction: zod_1.z.enum(['asc', 'desc']),
    })
        .strict())
        .max(8)
        .optional(),
    filter: zod_1.z.unknown().optional(),
})
    .strict();
exports.CustomAppInternalLiveCellSchema = zod_1.z
    .object({
    value: zod_1.z.unknown(),
})
    .strict();
exports.CustomAppInternalLiveDatasetWindowResponseSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    columns: zod_1.z.array(zod_1.z
        .object({
        id: zod_1.z.string().min(1),
        name: zod_1.z.string().min(1),
        type: zod_1.z.string().min(1),
    })
        .strict()),
    rows: zod_1.z.array(zod_1.z
        .object({
        id: zod_1.z.string().min(1),
        cells: zod_1.z.record(zod_1.z.string().min(1), exports.CustomAppInternalLiveCellSchema),
        updatedAt: zod_1.z.string().min(1).optional(),
    })
        .strict()),
    nextCursor: zod_1.z.string().min(1).nullable().optional(),
    revision: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.CustomAppInternalLiveCommandRequestSchema = zod_1.z
    .object({
    requestId: exports.CustomAppInvocationRequestIdSchema,
    appId: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    commandId: zod_1.z.string().min(1),
    capabilityId: zod_1.z.string().min(1).optional(),
    input: zod_1.z.unknown(),
})
    .strict();
exports.CustomAppPlatformCapabilityIdSchema = zod_1.z.enum([
    'dataset.readWindow',
    'dataset.subscribe',
    'database.row.insert',
    'agentAction.invoke',
    'automation.run',
    'attachment.update',
    'document.export',
]);
exports.CustomAppCapabilityPermissionSchema = zod_1.z.enum([
    'read',
    'write',
    'execute',
    'manage',
]);
exports.CustomAppCapabilitySchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    capabilityId: exports.CustomAppPlatformCapabilityIdSchema,
    label: zod_1.z.string().min(1),
    permission: exports.CustomAppCapabilityPermissionSchema.default('read'),
    routePaths: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actionIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    quotaKey: zod_1.z.string().min(1).optional(),
    secretBindingKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
exports.CustomAppEffectivePrincipalTypeSchema = zod_1.z.enum([
    'anonymous',
    'portal',
    'workspaceMember',
    'guest',
]);
exports.CustomAppExposureCapabilityDecisionSchema = zod_1.z
    .object({
    allowed: zod_1.z.boolean(),
    effectivePrincipal: exports.CustomAppEffectivePrincipalTypeSchema,
    reason: zod_1.z.enum([
        'allowed',
        'profile_denied',
        'principal_denied',
        'action_audience_denied',
        'binding_audience_denied',
        'capability_denied',
    ]),
})
    .strict();
function decideCustomAppExposureCapability(input) {
    const effectivePrincipal = effectiveCustomAppPrincipal(input);
    const deny = (reason) => exports.CustomAppExposureCapabilityDecisionSchema.parse({
        allowed: false,
        effectivePrincipal,
        reason,
    });
    const allow = () => exports.CustomAppExposureCapabilityDecisionSchema.parse({
        allowed: true,
        effectivePrincipal,
        reason: 'allowed',
    });
    const isSnapshotReadCapability = input.capability === 'dataset.readWindow' ||
        input.capability === 'document.export';
    switch (input.exposureProfile) {
        case 'publicStatic':
            if (effectivePrincipal !== 'anonymous')
                return deny('principal_denied');
            if (input.actionAudience !== 'public')
                return deny('action_audience_denied');
            if (input.bindingAudience !== 'public')
                return deny('binding_audience_denied');
            return isSnapshotReadCapability ? allow() : deny('capability_denied');
        case 'publicInteractive':
            if (effectivePrincipal !== 'anonymous')
                return deny('principal_denied');
            if (input.actionAudience !== 'public')
                return deny('action_audience_denied');
            if (input.bindingAudience !== 'public')
                return deny('binding_audience_denied');
            return isSnapshotReadCapability ||
                input.capability === 'database.row.insert'
                ? allow()
                : deny('capability_denied');
        case 'memberPortal':
            if (effectivePrincipal === 'portal') {
                if (input.actionAudience !== 'portal')
                    return deny('action_audience_denied');
                if (input.bindingAudience !== 'portal')
                    return deny('binding_audience_denied');
                return input.capability === 'automation.run' ||
                    input.capability === 'dataset.subscribe' ||
                    input.capability === 'agentAction.invoke'
                    ? deny('capability_denied')
                    : allow();
            }
            if (effectivePrincipal !== 'workspaceMember')
                return deny('principal_denied');
            if (!isMemberAudience(input.actionAudience))
                return deny('action_audience_denied');
            if (!isMemberAudience(input.bindingAudience))
                return deny('binding_audience_denied');
            return input.capability === 'dataset.subscribe' ||
                input.capability === 'agentAction.invoke'
                ? deny('capability_denied')
                : allow();
        case 'internalLive':
            if (effectivePrincipal !== 'workspaceMember')
                return deny('principal_denied');
            if (!isMemberAudience(input.actionAudience))
                return deny('action_audience_denied');
            if (!isMemberAudience(input.bindingAudience))
                return deny('binding_audience_denied');
            return allow();
    }
}
function effectiveCustomAppPrincipal(input) {
    if (input.actionAudience === 'portal' || input.bindingAudience === 'portal') {
        return input.principal === 'workspaceMember' || input.principal === 'portal'
            ? 'portal'
            : input.principal;
    }
    if (input.actionAudience === 'public' &&
        input.bindingAudience === 'public' &&
        (input.principal === 'workspaceMember' || input.principal === 'guest')) {
        return 'anonymous';
    }
    return input.principal;
}
function isMemberAudience(audience) {
    return audience === 'members' || audience === 'internal';
}
exports.CustomAppInvocationIdentitySchema = zod_1.z
    .object({
    contractVersion: zod_1.z.literal(exports.CUSTOM_APP_INVOCATION_IDENTITY_CONTRACT_VERSION),
    requestId: exports.CustomAppInvocationRequestIdSchema,
    workspaceId: zod_1.z.string().min(1),
    customAppId: zod_1.z.string().min(1),
    appId: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    actionId: zod_1.z.string().min(1),
    actionRevision: zod_1.z.number().int().nonnegative(),
    candidateDigest: zod_1.z.string().regex(/^[0-9a-f]{64}$/),
    exposurePolicyVersion: zod_1.z.literal(exports.CUSTOM_APP_EXPOSURE_PROFILE_SCHEMA_VERSION),
    activationEpoch: zod_1.z.string().regex(/^\d+$/).optional(),
    principalType: exports.CustomAppEffectivePrincipalTypeSchema,
    principalId: zod_1.z.string().min(1),
    payloadDigest: zod_1.z.string().regex(/^[0-9a-f]{64}$/),
    operationKind: zod_1.z.enum(['rowInsert', 'attachmentUpdate', 'automationRun']),
    bindingId: zod_1.z.string().min(1).optional(),
    bindingEpoch: zod_1.z.string().regex(/^\d+$/).optional(),
    targetDocId: zod_1.z.string().min(1).optional(),
    databaseBlockId: zod_1.z.string().min(1).optional(),
    rowId: zod_1.z.string().min(1).optional(),
    columnId: zod_1.z.string().min(1).optional(),
    permissionEpoch: zod_1.z.string().regex(/^\d+$/).optional(),
})
    .strict()
    .superRefine((identity, ctx) => {
    if (identity.principalType === 'anonymous' &&
        identity.principalId !== 'anonymous') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Anonymous invocations require the canonical anonymous ID',
            path: ['principalId'],
        });
    }
    if (identity.operationKind === 'automationRun' &&
        !identity.activationEpoch) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Automation invocations require activationEpoch',
            path: ['activationEpoch'],
        });
    }
    if (identity.operationKind !== 'automationRun') {
        for (const field of [
            'bindingId',
            'bindingEpoch',
            'targetDocId',
            'databaseBlockId',
            'permissionEpoch',
        ]) {
            if (identity[field])
                continue;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Mutation invocations require ${field}`,
                path: [field],
            });
        }
    }
    if (identity.operationKind === 'attachmentUpdate' &&
        (!identity.rowId || !identity.columnId)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Attachment invocations require rowId and columnId',
            path: [identity.rowId ? 'columnId' : 'rowId'],
        });
    }
})
    .transform(identity => ({
    ...identity,
    routePath: normalizeCustomAppInvocationRoute(identity.routePath),
}));
function canonicalCustomAppInvocationIdentity(input) {
    return canonicalCustomAppJson(exports.CustomAppInvocationIdentitySchema.parse(input));
}
function deriveCustomAppInvocationOperationId(input) {
    const canonical = canonicalCustomAppInvocationIdentity(input);
    const fingerprint = customAppSha256Hex(canonical);
    return {
        fingerprint,
        operationId: customAppSha256Hex(`${exports.CUSTOM_APP_INVOCATION_IDENTITY_CONTRACT_VERSION}:${fingerprint}`),
    };
}
function customAppCanonicalPayloadDigest(value) {
    return customAppSha256Hex(canonicalCustomAppJson(value));
}
function normalizeCustomAppInvocationRoute(path) {
    const normalized = `/${path.trim().replace(/^\/+|\/+$/g, '')}`;
    if (!isSafeCustomAppRoutePath(normalized)) {
        throw new Error('Invalid custom app invocation route');
    }
    return normalized === '/' ? '/' : normalized;
}
function canonicalCustomAppJson(value) {
    if (value === null || typeof value !== 'object')
        return JSON.stringify(value);
    if (Array.isArray(value)) {
        return `[${value.map(canonicalCustomAppJson).join(',')}]`;
    }
    return `{${Object.entries(value)
        .filter(([, entry]) => entry !== undefined)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, entry]) => `${JSON.stringify(key)}:${canonicalCustomAppJson(entry)}`)
        .join(',')}}`;
}
exports.CustomAppBuildingBlockKindSchema = zod_1.z.enum([
    'dataSource',
    'action',
    'capability',
    'documentExport',
    'routeModule',
    'asset',
]);
exports.CustomAppBuildingBlockRefSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    kind: exports.CustomAppBuildingBlockKindSchema,
    label: zod_1.z.string().min(1).optional(),
    family: zod_1.z.string().min(1).optional(),
    sourceKey: zod_1.z.string().min(1).optional(),
    actionId: zod_1.z.string().min(1).optional(),
    capabilityId: exports.CustomAppPlatformCapabilityIdSchema.optional(),
    exportId: zod_1.z.string().min(1).optional(),
    routePath: zod_1.z.string().min(1).optional(),
    metadata: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.unknown()).optional(),
})
    .strict();
function isSafeCustomAppRoutePath(path) {
    if (!path.startsWith('/'))
        return false;
    if (path.includes('://') || path.startsWith('//'))
        return false;
    return !path
        .replace(/\\/g, '/')
        .split('/')
        .filter(Boolean)
        .some(part => part === '.' || part === '..');
}
exports.CustomAppRouteSchema = zod_1.z
    .object({
    path: zod_1.z.string().min(1),
    title: zod_1.z.string().min(1),
    entry: zod_1.z.string().min(1).default('index.html'),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    navigation: zod_1.z.boolean().default(true),
    audience: exports.CustomAppDatabaseBindingAudienceSchema.default('public'),
    dynamicSlugSourceKey: zod_1.z.string().min(1).optional(),
    dynamicSlugColumnId: zod_1.z.string().min(1).optional(),
})
    .strict()
    .superRefine((route, ctx) => {
    if (!isSafeCustomAppRoutePath(route.path)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom app routes must be absolute workspace paths without traversal or URL syntax',
            path: ['path'],
        });
    }
});
exports.CustomAppNavigationItemSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    labelsI18n: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.string().min(1)).optional(),
    path: zod_1.z.string().min(1),
    order: zod_1.z.number().int().nonnegative().default(0),
})
    .strict();
exports.CustomAppActionFieldSchema = zod_1.z
    .object({
    columnId: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z
        .enum([
        'text',
        'textarea',
        'email',
        'url',
        'number',
        'date',
        'select',
        'multi-select',
        'checkbox',
    ])
        .default('text'),
    required: zod_1.z.boolean().default(false),
    maxLength: zod_1.z.number().int().positive().max(4000).optional(),
    options: zod_1.z.array(zod_1.z.string().min(1)).max(128).optional(),
})
    .strict();
exports.CustomAppRowInsertActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z.literal('rowInsert'),
    sourceKey: zod_1.z.string().min(1),
    audience: exports.CustomAppDatabaseBindingAudienceSchema.default('public'),
    fields: zod_1.z.array(exports.CustomAppActionFieldSchema).default([]),
    consentRequired: zod_1.z.boolean().default(false),
})
    .strict();
exports.CustomAppAutomationInputBindingSchema = zod_1.z
    .object({
    targetField: zod_1.z.string().min(1),
    source: zod_1.z.enum(['payload', 'route', 'row', 'user', 'constant']),
    sourceKey: zod_1.z.string().min(1).optional(),
    columnId: zod_1.z.string().min(1).optional(),
    routeParam: zod_1.z.string().min(1).optional(),
    payloadPath: zod_1.z.string().min(1).optional(),
    value: zod_1.z.unknown().optional(),
})
    .strict();
exports.CustomAppAutomationResultPresentationSchema = zod_1.z
    .object({
    type: zod_1.z.enum([
        'statusOnly',
        'tableReview',
        'attachmentGallery',
        'imageReview',
        'fileReview',
    ]),
    sourceKey: zod_1.z.string().min(1).optional(),
    columns: zod_1.z.array(zod_1.z.string().min(1)).max(64).default([]),
    filterSourceKey: zod_1.z.string().min(1).optional(),
    primaryAttachmentColumnId: zod_1.z.string().min(1).optional(),
    primaryImageColumnId: zod_1.z.string().min(1).optional(),
    blobOpenMode: zod_1.z
        .enum(['inline', 'fullscreen', 'download'])
        .default('inline'),
    editable: zod_1.z.boolean().default(false),
    saveActionId: zod_1.z.string().min(1).optional(),
    rowLimit: zod_1.z.number().int().positive().max(500).default(50),
})
    .strict()
    .superRefine((presentation, ctx) => {
    if (presentation.type !== 'statusOnly' && !presentation.sourceKey) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Result presentations other than statusOnly require sourceKey',
            path: ['sourceKey'],
        });
    }
    if (presentation.editable && !presentation.saveActionId) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Editable result presentations require saveActionId',
            path: ['saveActionId'],
        });
    }
});
exports.CustomAppAutomationRunActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z.literal('automationRun'),
    automationKey: zod_1.z.string().min(1),
    blockId: zod_1.z.string().min(1),
    automationTemplateId: zod_1.z.string().min(1).optional(),
    docId: zod_1.z.string().min(1).optional(),
    automationId: zod_1.z.string().min(1).optional(),
    workflowId: zod_1.z.string().min(1).optional(),
    inputSourceKey: zod_1.z.string().min(1).optional(),
    inputBindings: zod_1.z.array(exports.CustomAppAutomationInputBindingSchema).default([]),
    resultPresentation: exports.CustomAppAutomationResultPresentationSchema.default({
        type: 'statusOnly',
    }),
    audience: zod_1.z.enum(['members', 'internal']).default('members'),
    consentRequired: zod_1.z.boolean().default(false),
    statusExposure: zod_1.z.literal('summary').default('summary'),
})
    .strict();
exports.CustomAppAttachmentUpdateActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z.literal('attachmentUpdate'),
    sourceKey: zod_1.z.string().min(1),
    rowIdBinding: zod_1.z.string().min(1),
    columnId: zod_1.z.string().min(1),
    mode: zod_1.z.enum(['replace', 'append', 'newRow']).default('replace'),
    acceptedMimeTypes: zod_1.z
        .array(zod_1.z.string().min(1))
        .min(1)
        .max(16)
        .default(['image/png', 'image/jpeg', 'image/webp']),
    maxBytes: zod_1.z
        .number()
        .int()
        .positive()
        .max(25 * 1024 * 1024)
        .default(10 * 1024 * 1024),
    preservePrevious: zod_1.z.boolean().default(true),
    audience: zod_1.z.enum(['members', 'internal', 'portal']).default('members'),
    consentRequired: zod_1.z.boolean().default(true),
})
    .strict();
exports.CustomAppActionSchema = zod_1.z.discriminatedUnion('type', [
    exports.CustomAppRowInsertActionSchema,
    exports.CustomAppAutomationRunActionSchema,
    exports.CustomAppAttachmentUpdateActionSchema,
]);
exports.CustomAppDocumentExportFormatSchema = zod_1.z.enum([
    'png',
    'jpeg',
    'pdf',
]);
exports.CustomAppDocumentExportSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_DOCUMENT_EXPORT_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    selector: zod_1.z.string().min(1),
    formats: zod_1.z.array(exports.CustomAppDocumentExportFormatSchema).min(1).max(4),
    defaultFormat: exports.CustomAppDocumentExportFormatSchema,
    filenameTemplate: zod_1.z.string().min(1).max(160),
    targetActionId: zod_1.z.string().min(1).optional(),
})
    .strict()
    .superRefine((documentExport, ctx) => {
    if (documentExport.formats.includes(documentExport.defaultFormat))
        return;
    ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: 'Document export defaultFormat must be included in formats',
        path: ['defaultFormat'],
    });
});
const CustomAppLiveDataScopeEntrySchema = zod_1.z.enum([
    'dataset-invalidations',
    'automation-status',
]);
exports.CustomAppBlockVisibilityContractSchema = zod_1.z
    .object({
    capabilityClass: exports.CustomAppBlockCapabilityClassSchema,
    requiredCapabilities: zod_1.z
        .array(exports.CustomAppPlatformCapabilityIdSchema)
        .default([]),
    publicSafe: zod_1.z.boolean().default(false),
    requiresAuth: zod_1.z.boolean().default(true),
    requiresWrite: zod_1.z.boolean().default(false),
    requiresSecret: zod_1.z.boolean().default(false),
    liveDataScopes: zod_1.z.array(CustomAppLiveDataScopeEntrySchema).default([]),
})
    .strict();
/** Portable Agent Action owned by exactly one App Block. */
exports.CustomAppAgentActionResourceBindingSchema = zod_1.z
    .object({
    bindingKey: zod_1.z.string().regex(/^[a-z][a-z0-9_]{0,63}$/),
    sourceKey: zod_1.z.string().min(1),
    allowedColumnIds: zod_1.z.array(zod_1.z.string().min(1)).min(1).max(128),
    accessMode: zod_1.z.enum(['READ', 'WRITE']),
    lookupKeys: zod_1.z
        .array(zod_1.z
        .object({
        name: zod_1.z.string().regex(/^[a-z][a-z0-9_]{0,63}$/),
        columnId: zod_1.z.string().min(1),
    })
        .strict())
        .max(16)
        .default([]),
    relationTargetKeys: zod_1.z.array(zod_1.z.string().min(1)).max(32).default([]),
})
    .strict();
exports.CustomAppAgentActionDefinitionSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_AGENT_ACTION_DEFINITION_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    name: zod_1.z.string().regex(/^[a-z][a-z0-9_]{2,63}$/),
    displayName: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().min(1).max(500),
    contract: zod_1.z.unknown(),
    bindings: zod_1.z.array(exports.CustomAppAgentActionResourceBindingSchema).min(1).max(32),
})
    .strict()
    .superRefine((action, ctx) => {
    const bindingKeys = action.bindings.map(binding => binding.bindingKey);
    if (new Set(bindingKeys).size !== bindingKeys.length) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Agent Action binding keys must be unique',
            path: ['bindings'],
        });
    }
});
exports.CustomAppBlockSeoStrategySchema = zod_1.z.enum([
    'pageRoute',
    'contentRow',
    'formRoute',
    'internalRoute',
]);
exports.CustomAppBlockSeoMetadataSourceSchema = zod_1.z.enum([
    'static',
    'row',
    'route',
    'none',
]);
exports.CustomAppBlockSeoCanonicalSchema = zod_1.z.enum([
    'auto',
    'rowField',
    'disabled',
]);
exports.CustomAppBlockSeoHreflangSchema = zod_1.z.enum([
    'appLocales',
    'rowGroup',
    'none',
]);
exports.CustomAppBlockSeoAiSearchSchema = zod_1.z
    .object({
    llmsTxt: zod_1.z.enum(['include', 'exclude']).default('exclude'),
    semanticSummary: zod_1.z.enum(['required', 'optional', 'none']).default('none'),
    robotsAiPolicy: zod_1.z.enum(['allow', 'noai', 'noimageai']).default('noai'),
})
    .strict();
exports.CustomAppBlockSeoContractSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_BLOCK_SEO_CONTRACT_SCHEMA_VERSION),
    strategy: exports.CustomAppBlockSeoStrategySchema,
    indexableByDefault: zod_1.z.boolean().default(false),
    metadataSource: exports.CustomAppBlockSeoMetadataSourceSchema.default('none'),
    structuredDataTypes: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    canonical: exports.CustomAppBlockSeoCanonicalSchema.default('disabled'),
    hreflang: exports.CustomAppBlockSeoHreflangSchema.default('none'),
    aiSearch: exports.CustomAppBlockSeoAiSearchSchema.default({}),
})
    .strict()
    .superRefine((contract, ctx) => {
    if (contract.strategy === 'internalRoute' && contract.indexableByDefault) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Internal AppBlock SEO routes must default to noindex',
            path: ['indexableByDefault'],
        });
    }
    if (contract.indexableByDefault && contract.metadataSource === 'none') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Indexable AppBlock SEO routes require metadataSource other than none',
            path: ['metadataSource'],
        });
    }
    if (contract.strategy === 'internalRoute' &&
        contract.aiSearch.llmsTxt === 'include') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Internal AppBlock SEO routes cannot be included in llms.txt',
            path: ['aiSearch', 'llmsTxt'],
        });
    }
    if (contract.metadataSource === 'none' &&
        contract.structuredDataTypes.length > 0) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Structured data requires SEO metadataSource',
            path: ['structuredDataTypes'],
        });
    }
});
exports.CustomAppCompiledRouteSeoOwnerSchema = zod_1.z.discriminatedUnion('kind', [
    zod_1.z
        .object({
        kind: zod_1.z.literal('shell'),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('appBlock'),
        mountId: zod_1.z.string().min(1),
        appBlockId: zod_1.z.string().min(1),
    })
        .strict(),
]);
exports.CustomAppCompiledRouteSeoSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_COMPILED_ROUTE_SEO_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    appLevel: zod_1.z.boolean().default(false),
    owner: exports.CustomAppCompiledRouteSeoOwnerSchema,
    strategy: exports.CustomAppBlockSeoStrategySchema,
    indexableByDefault: zod_1.z.boolean(),
    metadataSource: exports.CustomAppBlockSeoMetadataSourceSchema,
    structuredDataTypes: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    canonical: exports.CustomAppBlockSeoCanonicalSchema,
    hreflang: exports.CustomAppBlockSeoHreflangSchema,
    aiSearch: exports.CustomAppBlockSeoAiSearchSchema,
    robotsDirectives: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
function hasRoutePolicy(input) {
    return input.policies.some(policy => policy.cacheClass === input.cacheClass &&
        (policy.path === input.pathPrefix ||
            policy.path.startsWith(`${input.pathPrefix}/`)));
}
function requireRoutePolicy(ctx, policies, input) {
    if (hasRoutePolicy({
        policies,
        pathPrefix: input.pathPrefix,
        cacheClass: input.cacheClass,
    })) {
        return;
    }
    ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: `Custom app ${input.label} requires routePolicies entry ${input.pathPrefix} with cacheClass ${input.cacheClass}`,
        path: ['delivery', 'routePolicies'],
    });
}
exports.CustomAppInteractionControlKindSchema = zod_1.z.enum([
    'route',
    'action',
    'field',
    'status',
    'dataset',
    'export',
]);
exports.CustomAppInteractionIntentSchema = zod_1.z.enum([
    'navigate',
    'rowInsert',
    'automationRun',
    'editField',
    'readStatus',
    'readDataset',
    'openAttachment',
    'saveAttachment',
    'exportDocument',
]);
exports.CustomAppInteractionRequiredRoleSchema = zod_1.z.enum([
    'reader',
    'writer',
    'manager',
]);
exports.CustomAppInteractionConfirmationPolicySchema = zod_1.z.enum([
    'none',
    'recommended',
    'required',
]);
exports.CustomAppInteractionControlSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    kind: exports.CustomAppInteractionControlKindSchema,
    intent: exports.CustomAppInteractionIntentSchema,
    routePath: zod_1.z.string().min(1).optional(),
    actionId: zod_1.z.string().min(1).optional(),
    sourceKey: zod_1.z.string().min(1).optional(),
    exportId: zod_1.z.string().min(1).optional(),
    fieldColumnId: zod_1.z.string().min(1).optional(),
    fieldType: exports.CustomAppActionFieldSchema.shape.type.optional(),
    fieldRequired: zod_1.z.boolean().optional(),
    fieldOptions: zod_1.z.array(zod_1.z.string().min(1)).max(128).optional(),
    formats: zod_1.z.array(exports.CustomAppDocumentExportFormatSchema).max(4).optional(),
    selector: zod_1.z.string().min(1).optional(),
    filenameTemplate: zod_1.z.string().min(1).max(160).optional(),
    statePath: zod_1.z.string().min(1).optional(),
    requiredRole: exports.CustomAppInteractionRequiredRoleSchema.default('reader'),
    confirmationPolicy: exports.CustomAppInteractionConfirmationPolicySchema.default('none'),
    description: zod_1.z.string().min(1).max(500).optional(),
})
    .strict();
exports.CustomAppInteractionContractSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_INTERACTION_CONTRACT_SCHEMA_VERSION),
    protocol: zod_1.z.literal('streamlain-custom-app-bridge/v1'),
    controls: zod_1.z.array(exports.CustomAppInteractionControlSchema).default([]),
    runtimeHints: zod_1.z.array(zod_1.z.string().min(1).max(500)).max(32).default([]),
})
    .strict()
    .superRefine((contract, ctx) => {
    const seen = new Set();
    for (const [index, control] of contract.controls.entries()) {
        if (!seen.has(control.id)) {
            seen.add(control.id);
            continue;
        }
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `Duplicate custom app interaction control id ${control.id}`,
            path: ['controls', index, 'id'],
        });
    }
});
exports.CustomAppManifestBaseSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_MANIFEST_SCHEMA_VERSION),
    appId: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1),
    entry: zod_1.z.string().min(1).default('index.html'),
    delivery: exports.CustomAppDeliverySchema.default({}),
    routes: zod_1.z.array(exports.CustomAppRouteSchema).default([]),
    navigation: zod_1.z.array(exports.CustomAppNavigationItemSchema).default([]),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actions: zod_1.z.array(exports.CustomAppActionSchema).default([]),
    capabilities: zod_1.z.array(exports.CustomAppCapabilitySchema).optional(),
    documentExports: zod_1.z.array(exports.CustomAppDocumentExportSchema).default([]),
    routeSeo: zod_1.z.array(exports.CustomAppCompiledRouteSeoSchema).default([]),
    interaction: exports.CustomAppInteractionContractSchema.optional(),
})
    .strict();
exports.CustomAppManifestSchema = exports.CustomAppManifestBaseSchema.superRefine((manifest, ctx) => {
    const policies = manifest.delivery.routePolicies;
    const actionDataSourceKeys = manifest.actions.flatMap(action => {
        if (action.type === 'rowInsert')
            return [action.sourceKey];
        if (action.type === 'attachmentUpdate')
            return [action.sourceKey];
        return [
            action.inputSourceKey,
            action.resultPresentation.sourceKey,
            action.resultPresentation.filterSourceKey,
        ].filter((value) => Boolean(value));
    });
    // A public-static artifact may declare publish-time data sources whose
    // values are materialized into the artifact. Only runtime-backed modes
    // expose a data endpoint.
    const usesCustomData = manifest.delivery.mode !== 'public_static' &&
        (manifest.dataSourceKeys.length > 0 ||
            manifest.routes.some(route => route.dataSourceKeys.length > 0) ||
            actionDataSourceKeys.length > 0);
    if (usesCustomData) {
        if (manifest.delivery.mode === 'internal_live') {
            requireRoutePolicy(ctx, policies, {
                pathPrefix: exports.CUSTOM_APP_INTERNAL_LIVE_DATA_ROUTE,
                cacheClass: 'internalLiveData',
                label: 'internal live data endpoint',
            });
        }
        else {
            requireRoutePolicy(ctx, policies, {
                pathPrefix: exports.CUSTOM_APP_EXTERNAL_DATA_ROUTE,
                cacheClass: 'customData',
                label: 'data endpoint',
            });
        }
    }
    if (manifest.actions.length > 0) {
        if (manifest.delivery.mode === 'internal_live') {
            requireRoutePolicy(ctx, policies, {
                pathPrefix: exports.CUSTOM_APP_INTERNAL_LIVE_COMMAND_ROUTE,
                cacheClass: 'internalLiveCommand',
                label: 'internal live command endpoint',
            });
        }
        else {
            requireRoutePolicy(ctx, policies, {
                pathPrefix: exports.CUSTOM_APP_EXTERNAL_ACTION_ROUTE,
                cacheClass: 'customAction',
                label: 'action endpoint',
            });
        }
    }
    const routePaths = new Set();
    manifest.routes.forEach((route, index) => {
        if (routePaths.has(route.path)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate custom app route path ${route.path}`,
                path: ['routes', index, 'path'],
            });
        }
        routePaths.add(route.path);
    });
    manifest.navigation.forEach((item, index) => {
        if (!routePaths.has(item.path)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom app navigation paths must reference declared routes',
                path: ['navigation', index, 'path'],
            });
        }
    });
    const routeSeoIds = new Set();
    let appLevelSeoOwner = null;
    manifest.routeSeo.forEach((routeSeo, index) => {
        if (routeSeoIds.has(routeSeo.id)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate custom app route SEO id ${routeSeo.id}`,
                path: ['routeSeo', index, 'id'],
            });
        }
        routeSeoIds.add(routeSeo.id);
        const route = manifest.routes.find(item => item.path === routeSeo.routePath);
        if (!route) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom app route SEO must reference a declared route path',
                path: ['routeSeo', index, 'routePath'],
            });
        }
        if (routeSeo.indexableByDefault && route?.audience !== 'public') {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom app route SEO can be indexable only for public routes',
                path: ['routeSeo', index, 'indexableByDefault'],
            });
        }
        if (routeSeo.strategy === 'internalRoute' &&
            routeSeo.indexableByDefault) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Internal custom app route SEO must be noindex',
                path: ['routeSeo', index, 'indexableByDefault'],
            });
        }
        if (!routeSeo.appLevel)
            return;
        if (appLevelSeoOwner) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Custom app app-level SEO already owned by ${appLevelSeoOwner}`,
                path: ['routeSeo', index, 'appLevel'],
            });
        }
        appLevelSeoOwner =
            routeSeo.owner.kind === 'shell'
                ? 'shell'
                : `${routeSeo.owner.mountId}/${routeSeo.owner.appBlockId}`;
    });
    const manifestDataSourceKeys = new Set([
        ...manifest.dataSourceKeys,
        ...manifest.routes.flatMap(route => route.dataSourceKeys),
        ...actionDataSourceKeys,
    ]);
    const actionsById = new Map(manifest.actions.map(action => [action.id, action]));
    const capabilityIds = new Set();
    (manifest.capabilities ?? []).forEach((capability, index) => {
        if (capabilityIds.has(capability.id)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate custom app capability id ${capability.id}`,
                path: ['capabilities', index, 'id'],
            });
        }
        capabilityIds.add(capability.id);
        for (const [routeIndex, routePath] of capability.routePaths.entries()) {
            if (!routePaths.has(routePath)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'Custom app capability routePaths must reference declared routes',
                    path: ['capabilities', index, 'routePaths', routeIndex],
                });
            }
        }
        for (const [sourceIndex, sourceKey,] of capability.dataSourceKeys.entries()) {
            if (!manifestDataSourceKeys.has(sourceKey)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'Custom app capability dataSourceKeys must reference declared data sources',
                    path: ['capabilities', index, 'dataSourceKeys', sourceIndex],
                });
            }
        }
        for (const [actionIndex, actionId] of capability.actionIds.entries()) {
            if (!actionsById.has(actionId)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'Custom app capability actionIds must reference declared actions',
                    path: ['capabilities', index, 'actionIds', actionIndex],
                });
            }
        }
    });
    const documentExportIds = new Set();
    manifest.documentExports.forEach((documentExport, index) => {
        if (documentExportIds.has(documentExport.id)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate custom app document export id ${documentExport.id}`,
                path: ['documentExports', index, 'id'],
            });
        }
        documentExportIds.add(documentExport.id);
        if (!routePaths.has(documentExport.routePath)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom app document export routePath must reference a declared route',
                path: ['documentExports', index, 'routePath'],
            });
        }
        if (!documentExport.targetActionId)
            return;
        const action = actionsById.get(documentExport.targetActionId);
        if (action?.type === 'attachmentUpdate')
            return;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom app document export targetActionId must reference an attachmentUpdate action',
            path: ['documentExports', index, 'targetActionId'],
        });
    });
    if (manifest.delivery.liveData.enabled) {
        if (manifest.delivery.mode === 'public_static') {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom app live data requires public_interactive, member_portal, or internal_live delivery mode',
                path: ['delivery', 'mode'],
            });
        }
        if (manifest.delivery.mode === 'internal_live') {
            requireRoutePolicy(ctx, policies, {
                pathPrefix: exports.CUSTOM_APP_INTERNAL_LIVE_EVENTS_ROUTE,
                cacheClass: 'internalLiveEvents',
                label: 'internal live events endpoint',
            });
        }
        else {
            requireRoutePolicy(ctx, policies, {
                pathPrefix: exports.CUSTOM_APP_EXTERNAL_EVENTS_ROUTE,
                cacheClass: 'customEvents',
                label: 'live events endpoint',
            });
        }
    }
    else if (manifest.delivery.liveData.scope !== 'none') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom app live data scope requires liveData.enabled=true',
            path: ['delivery', 'liveData', 'scope'],
        });
    }
    manifest.routes.forEach((route, index) => {
        if (route.dynamicSlugColumnId && !route.dynamicSlugSourceKey) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom app dynamic slug columns require dynamicSlugSourceKey',
                path: ['routes', index, 'dynamicSlugSourceKey'],
            });
        }
        if (route.dynamicSlugSourceKey &&
            !route.dataSourceKeys.includes(route.dynamicSlugSourceKey)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom app dynamic slug source must be listed in route dataSourceKeys',
                path: ['routes', index, 'dynamicSlugSourceKey'],
            });
        }
    });
});
exports.CustomAppCompositionShellSchema = zod_1.z
    .object({
    appId: zod_1.z.string().min(1).default('custom'),
    name: zod_1.z.string().min(1),
    entry: zod_1.z.string().min(1).default('index.html'),
    exposureProfile: exports.CustomAppExposureProfileSchema.default('publicStatic'),
    rootRoutePath: zod_1.z.literal('/').default('/'),
})
    .strict();
exports.CustomAppAppBlockMountSlotSchema = zod_1.z.enum(['main', 'aside']);
exports.CustomAppAppBlockNavigationPlacementSchema = zod_1.z.enum([
    'primary',
    'secondary',
    'hidden',
]);
exports.CustomAppAppBlockBindingRefSchema = zod_1.z
    .object({
    targetSourceKey: zod_1.z.string().min(1),
    required: zod_1.z.boolean().default(true),
})
    .strict();
exports.CustomAppAppBlockMountSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_APP_BLOCK_MOUNT_SCHEMA_VERSION),
    mountId: zod_1.z.string().min(1),
    appBlockId: zod_1.z.string().min(1),
    appBlockVersion: zod_1.z.string().min(1).optional(),
    slot: exports.CustomAppAppBlockMountSlotSchema.default('main'),
    order: zod_1.z.number().int().nonnegative().default(0),
    routePrefix: zod_1.z.string().min(1),
    entryRoutePath: zod_1.z.string().min(1).optional(),
    navigation: zod_1.z.boolean().default(true),
    navigationPlacement: exports.CustomAppAppBlockNavigationPlacementSchema.default('primary'),
    navigationLabel: zod_1.z.string().min(1).optional(),
    bindings: zod_1.z
        .record(zod_1.z.string().min(1), exports.CustomAppAppBlockBindingRefSchema)
        .default({}),
    props: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.unknown()).default({}),
})
    .strict()
    .superRefine((mount, ctx) => {
    if (!isSafeCustomAppRoutePath(mount.routePrefix)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom app block mount routePrefix must be an absolute workspace path without traversal or URL syntax',
            path: ['routePrefix'],
        });
    }
    if (mount.entryRoutePath &&
        !isSafeCustomAppRoutePath(mount.entryRoutePath)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom app block mount entryRoutePath must be an absolute workspace path without traversal or URL syntax',
            path: ['entryRoutePath'],
        });
    }
});
exports.CustomAppCompositionSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_COMPOSITION_SCHEMA_VERSION),
    compositionId: zod_1.z.string().min(1),
    revision: zod_1.z.number().int().positive().default(1),
    updatedAt: zod_1.z.string().min(1).optional(),
    shell: exports.CustomAppCompositionShellSchema,
    mounts: zod_1.z.array(exports.CustomAppAppBlockMountSchema).default([]),
})
    .strict()
    .superRefine((composition, ctx) => {
    const mountIds = new Set();
    const hasRootRouteMount = composition.mounts.some(mount => (mount.entryRoutePath ?? mount.routePrefix) ===
        composition.shell.rootRoutePath);
    const routePaths = new Set(hasRootRouteMount ? [] : [composition.shell.rootRoutePath]);
    const routePrefixes = new Set();
    composition.mounts.forEach((mount, index) => {
        const entryRoutePath = mount.entryRoutePath ?? mount.routePrefix;
        if (mountIds.has(mount.mountId)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate custom app mount id ${mount.mountId}`,
                path: ['mounts', index, 'mountId'],
            });
        }
        mountIds.add(mount.mountId);
        if (routePrefixes.has(mount.routePrefix)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate custom app composition route prefix ${mount.routePrefix}`,
                path: ['mounts', index, 'routePrefix'],
            });
        }
        routePrefixes.add(mount.routePrefix);
        if (routePaths.has(entryRoutePath)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate custom app composition route path ${entryRoutePath}`,
                path: ['mounts', index, 'entryRoutePath'],
            });
        }
        routePaths.add(entryRoutePath);
    });
});
const CustomAppCompositionMountPatchSchema = zod_1.z
    .object({
    routePrefix: zod_1.z.string().min(1).optional(),
    entryRoutePath: zod_1.z.string().min(1).optional(),
    navigation: zod_1.z.boolean().optional(),
    navigationPlacement: exports.CustomAppAppBlockNavigationPlacementSchema.optional(),
    navigationLabel: zod_1.z.string().min(1).optional(),
    bindings: zod_1.z
        .record(zod_1.z.string().min(1), exports.CustomAppAppBlockBindingRefSchema)
        .optional(),
    props: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.unknown()).optional(),
})
    .strict();
exports.CustomAppCompositionOperationSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('mountAppBlock'),
        mount: exports.CustomAppAppBlockMountSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('unmountAppBlock'),
        mountId: zod_1.z.string().min(1),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('unmountAppBlockEverywhere'),
        appBlockId: zod_1.z.string().min(1),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('updateMount'),
        mountId: zod_1.z.string().min(1),
        patch: CustomAppCompositionMountPatchSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('updateShell'),
        patch: exports.CustomAppCompositionShellSchema.pick({
            name: true,
            entry: true,
            exposureProfile: true,
        })
            .partial()
            .strict(),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('updateExposureProfile'),
        exposureProfile: exports.CustomAppExposureProfileSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('reorderMounts'),
        mountIds: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('setNavigationPlacement'),
        mountId: zod_1.z.string().min(1),
        navigation: zod_1.z.boolean(),
        navigationPlacement: exports.CustomAppAppBlockNavigationPlacementSchema.optional(),
        navigationLabel: zod_1.z.string().min(1).optional(),
    })
        .strict(),
]);
exports.CustomAppCompositionOperationBatchSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    operations: zod_1.z.array(exports.CustomAppCompositionOperationSchema).min(1),
})
    .strict();
exports.CustomAppCompiledArtifactProvenanceSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_COMPILED_ARTIFACT_PROVENANCE_SCHEMA_VERSION),
    source: zod_1.z.literal('customAppComposition'),
    compositionId: zod_1.z.string().min(1),
    compositionRevision: zod_1.z.number().int().positive(),
    compiledAt: zod_1.z.string().min(1),
    compilerVersion: zod_1.z.literal(exports.CUSTOM_APP_COMPOSITION_COMPILER_VERSION),
})
    .strict();
exports.CustomAppArtifactFileSchema = zod_1.z
    .object({
    path: zod_1.z.string().min(1),
    contentType: zod_1.z.string().min(1),
    sha256: zod_1.z.string().min(16),
    bytes: zod_1.z.number().int().nonnegative(),
    text: zod_1.z.string().optional(),
    storageKey: zod_1.z.string().min(1).optional(),
})
    .strict()
    .superRefine((file, ctx) => {
    if (file.text !== undefined || file.storageKey)
        return;
    ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: 'Custom app artifact file requires text or storageKey',
        path: ['text'],
    });
});
function isRoutePathWithinRootNamespace(routePath, rootRoutePath) {
    return (rootRoutePath === '/' ||
        routePath === rootRoutePath ||
        routePath.startsWith(`${rootRoutePath}/`));
}
exports.CustomAppRouteModuleSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_ROUTE_MODULE_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1).optional(),
    rootRoutePath: zod_1.z.string().min(1),
    routePaths: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    filePaths: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actionIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    navigationItemIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    interactionControlIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    buildingBlockRefs: zod_1.z.array(exports.CustomAppBuildingBlockRefSchema).default([]),
    assetRefs: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    shared: zod_1.z.boolean().default(false),
})
    .strict()
    .superRefine((routeModule, ctx) => {
    if (!routeModule.routePaths.includes(routeModule.rootRoutePath)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom app route module rootRoutePath must be in routePaths',
            path: ['rootRoutePath'],
        });
    }
    routeModule.routePaths.forEach((routePath, routeIndex) => {
        if (isRoutePathWithinRootNamespace(routePath, routeModule.rootRoutePath)) {
            return;
        }
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom app route module paths must belong to its rootRoutePath namespace',
            path: ['routePaths', routeIndex],
        });
    });
    const uniqueFields = [
        'routePaths',
        'filePaths',
        'dataSourceKeys',
        'actionIds',
        'navigationItemIds',
        'interactionControlIds',
        'assetRefs',
    ];
    for (const field of uniqueFields) {
        const values = routeModule[field];
        if (new Set(values).size === values.length)
            continue;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `Custom app route module ${field} must be unique`,
            path: [field],
        });
    }
    const buildingBlockIds = routeModule.buildingBlockRefs.map(ref => ref.id);
    if (new Set(buildingBlockIds).size !== buildingBlockIds.length) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom app route module buildingBlockRefs must be unique',
            path: ['buildingBlockRefs'],
        });
    }
});
exports.CustomAppAppBlockResourceDefinitionSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1).optional(),
    required: zod_1.z.boolean().default(true),
    role: zod_1.z.string().min(1).optional(),
    contentModel: zod_1.z.string().min(1).optional(),
    audience: exports.CustomAppDatabaseBindingAudienceSchema.optional(),
    allowWrites: zod_1.z.boolean().optional(),
})
    .strict();
exports.CustomAppAppBlockDefinitionOutputSchema = zod_1.z
    .object({
    visibility: exports.CustomAppBlockVisibilityContractSchema,
    routes: zod_1.z.array(exports.CustomAppRouteSchema).default([]),
    navigation: zod_1.z.array(exports.CustomAppNavigationItemSchema).default([]),
    resources: zod_1.z.array(exports.CustomAppAppBlockResourceDefinitionSchema).default([]),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actions: zod_1.z.array(exports.CustomAppActionSchema).default([]),
    documentExports: zod_1.z.array(exports.CustomAppDocumentExportSchema).default([]),
    files: zod_1.z.record(zod_1.z.string().min(1), exports.CustomAppArtifactFileSchema).default({}),
    routeModules: zod_1.z.array(exports.CustomAppRouteModuleSchema).default([]),
    routeSeo: zod_1.z.array(exports.CustomAppCompiledRouteSeoSchema).default([]),
})
    .strict();
exports.CustomAppAppBlockCompiledOutputSchema = exports.CustomAppAppBlockDefinitionOutputSchema.extend({
    mountId: zod_1.z.string().min(1),
}).strict();
exports.CustomAppAppBlockRouteDefinitionSchema = zod_1.z
    .object({
    route: exports.CustomAppRouteSchema,
    filePaths: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    interactionControlIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    buildingBlockRefs: zod_1.z.array(exports.CustomAppBuildingBlockRefSchema).default([]),
    assetRefs: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
exports.CustomAppBlockDefinitionSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_BLOCK_DEFINITION_SCHEMA_VERSION),
    appBlockId: zod_1.z.string().min(1),
    title: zod_1.z.string().min(1),
    rootRoutePath: zod_1.z.string().min(1),
    seo: exports.CustomAppBlockSeoContractSchema,
    visibility: exports.CustomAppBlockVisibilityContractSchema,
    routes: zod_1.z.array(exports.CustomAppAppBlockRouteDefinitionSchema).min(1),
    resources: zod_1.z.array(exports.CustomAppAppBlockResourceDefinitionSchema).default([]),
    commands: zod_1.z.array(exports.CustomAppActionSchema).default([]),
    agentActions: zod_1.z.array(exports.CustomAppAgentActionDefinitionSchema).default([]),
    exports: zod_1.z.array(exports.CustomAppDocumentExportSchema).default([]),
    navigation: zod_1.z.array(exports.CustomAppNavigationItemSchema).default([]),
    files: zod_1.z.record(zod_1.z.string().min(1), exports.CustomAppArtifactFileSchema).default({}),
})
    .strict()
    .superRefine((definition, ctx) => {
    const routePaths = definition.routes.map(route => route.route.path);
    const filePaths = new Set(Object.keys(definition.files));
    const commandIds = new Set(definition.commands.map(command => command.id));
    const exportIds = new Set(definition.exports.map(item => item.id));
    const navigationIds = new Set(definition.navigation.map(item => item.id));
    const routePathSet = new Set(routePaths);
    const addDuplicateIssues = (values, path, label) => {
        const seen = new Set();
        values.forEach((value, index) => {
            if (!seen.has(value)) {
                seen.add(value);
                return;
            }
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Custom AppBlock definition ${label} must be unique: ${value}`,
                path: [...path, index],
            });
        });
    };
    addDuplicateIssues(routePaths, ['routes'], 'route paths');
    addDuplicateIssues(definition.resources.map(resource => resource.sourceKey), ['resources'], 'resource sourceKeys');
    addDuplicateIssues(definition.commands.map(command => command.id), ['commands'], 'command ids');
    addDuplicateIssues(definition.agentActions.map(action => action.id), ['agentActions'], 'Agent Action ids');
    addDuplicateIssues(definition.agentActions.map(action => action.name), ['agentActions'], 'Agent Action names');
    addDuplicateIssues(definition.exports.map(item => item.id), ['exports'], 'export ids');
    addDuplicateIssues(definition.navigation.map(item => item.id), ['navigation'], 'navigation ids');
    const ownsRoot = routePaths.includes(definition.rootRoutePath);
    if (!ownsRoot) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom AppBlock definition must own its rootRoutePath',
            path: ['rootRoutePath'],
        });
    }
    definition.routes.forEach((route, routeIndex) => {
        if (isRoutePathWithinRootNamespace(route.route.path, definition.rootRoutePath)) {
            return;
        }
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom AppBlock routes must belong to its rootRoutePath namespace',
            path: ['routes', routeIndex, 'route', 'path'],
        });
    });
    const resourceKeys = new Set(definition.resources.map(resource => resource.sourceKey));
    definition.agentActions.forEach((action, actionIndex) => {
        action.bindings.forEach((binding, bindingIndex) => {
            if (resourceKeys.has(binding.sourceKey))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Agent Action bindings must reference App Block resources',
                path: [
                    'agentActions',
                    actionIndex,
                    'bindings',
                    bindingIndex,
                    'sourceKey',
                ],
            });
        });
    });
    definition.routes.forEach((route, routeIndex) => {
        if (!isCustomAppNativeRouteEntry(route.route.entry) &&
            !filePaths.has(route.route.entry)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock route entry must be declared in definition files',
                path: ['routes', routeIndex, 'route', 'entry'],
            });
        }
        route.filePaths.forEach((filePath, fileIndex) => {
            if (filePaths.has(filePath))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock route filePaths must be declared in definition files',
                path: ['routes', routeIndex, 'filePaths', fileIndex],
            });
        });
        route.assetRefs.forEach((assetRef, assetIndex) => {
            if (filePaths.has(assetRef))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock route assetRefs must be declared in definition files',
                path: ['routes', routeIndex, 'assetRefs', assetIndex],
            });
        });
        route.route.dataSourceKeys.forEach((sourceKey, sourceIndex) => {
            if (resourceKeys.has(sourceKey))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock route dataSourceKeys must reference declared resources',
                path: ['routes', routeIndex, 'route', 'dataSourceKeys', sourceIndex],
            });
        });
        route.buildingBlockRefs.forEach((ref, refIndex) => {
            if (ref.sourceKey && !resourceKeys.has(ref.sourceKey)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'Custom AppBlock buildingBlockRefs sourceKey must reference declared resources',
                    path: [
                        'routes',
                        routeIndex,
                        'buildingBlockRefs',
                        refIndex,
                        'sourceKey',
                    ],
                });
            }
            if (ref.actionId && !commandIds.has(ref.actionId)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'Custom AppBlock buildingBlockRefs actionId must reference declared commands',
                    path: [
                        'routes',
                        routeIndex,
                        'buildingBlockRefs',
                        refIndex,
                        'actionId',
                    ],
                });
            }
            if (ref.exportId && !exportIds.has(ref.exportId)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'Custom AppBlock buildingBlockRefs exportId must reference declared exports',
                    path: [
                        'routes',
                        routeIndex,
                        'buildingBlockRefs',
                        refIndex,
                        'exportId',
                    ],
                });
            }
            if (ref.routePath && !routePathSet.has(ref.routePath)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'Custom AppBlock buildingBlockRefs routePath must reference declared routes',
                    path: [
                        'routes',
                        routeIndex,
                        'buildingBlockRefs',
                        refIndex,
                        'routePath',
                    ],
                });
            }
        });
    });
    definition.commands.forEach((command, commandIndex) => {
        const referencedSourceKeys = command.type === 'rowInsert'
            ? [command.sourceKey]
            : command.type === 'attachmentUpdate'
                ? [command.sourceKey]
                : [
                    command.inputSourceKey,
                    ...command.inputBindings.map(binding => binding.sourceKey),
                    command.resultPresentation.sourceKey,
                    command.resultPresentation.filterSourceKey,
                ].filter((value) => Boolean(value));
        referencedSourceKeys.forEach(sourceKey => {
            if (resourceKeys.has(sourceKey))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock commands must reference declared resources for all source keys',
                path: ['commands', commandIndex],
            });
        });
        if (command.type === 'automationRun' &&
            command.resultPresentation.saveActionId &&
            !commandIds.has(command.resultPresentation.saveActionId)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock automationRun resultPresentation saveActionId must reference declared commands',
                path: [
                    'commands',
                    commandIndex,
                    'resultPresentation',
                    'saveActionId',
                ],
            });
        }
    });
    definition.exports.forEach((documentExport, exportIndex) => {
        if (!routePathSet.has(documentExport.routePath)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock document exports must reference declared routes',
                path: ['exports', exportIndex, 'routePath'],
            });
        }
        if (documentExport.targetActionId &&
            !commandIds.has(documentExport.targetActionId)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock document export targetActionId must reference declared commands',
                path: ['exports', exportIndex, 'targetActionId'],
            });
        }
    });
    definition.navigation.forEach((navigationItem, navigationIndex) => {
        if (routePathSet.has(navigationItem.path))
            return;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Custom AppBlock navigation must reference declared routes',
            path: ['navigation', navigationIndex, 'path'],
        });
    });
    definition.routes.forEach((route, routeIndex) => {
        route.interactionControlIds.forEach((controlId, controlIndex) => {
            const [prefix] = controlId.split(':', 1);
            if (!['route', 'action', 'export', 'nav', 'dataset'].includes(prefix ?? ''))
                return;
            if (controlId.startsWith(`route:${route.route.path}`))
                return;
            if (controlId.startsWith('action:')) {
                const actionId = actionIdFromInteractionControlId(controlId);
                if (actionId && commandIds.has(actionId))
                    return;
            }
            if (controlId.startsWith('export:') &&
                exportIds.has(controlId.slice('export:'.length)))
                return;
            if (controlId.startsWith('nav:') &&
                navigationIds.has(controlId.slice('nav:'.length)))
                return;
            if (controlId.startsWith('dataset:') &&
                resourceKeys.has(controlId.slice('dataset:'.length)))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Custom AppBlock interactionControlIds must reference route, command, export or navigation ownership',
                path: ['routes', routeIndex, 'interactionControlIds', controlIndex],
            });
        });
    });
});
function actionIdFromInteractionControlId(controlId) {
    if (!controlId.startsWith('action:'))
        return null;
    const actionControlId = controlId.slice('action:'.length);
    const fieldMarkerIndex = actionControlId.indexOf(':field:');
    return fieldMarkerIndex === -1
        ? actionControlId
        : actionControlId.slice(0, fieldMarkerIndex);
}
exports.CustomAppBlockDefinitionOperationSchema = zod_1.z
    .discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('defineAppBlock'),
        definition: exports.CustomAppBlockDefinitionSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('replaceAppBlockDefinition'),
        appBlockId: zod_1.z.string().min(1),
        definition: exports.CustomAppBlockDefinitionSchema,
    })
        .strict(),
])
    .superRefine((operation, ctx) => {
    if (operation.type !== 'replaceAppBlockDefinition')
        return;
    if (operation.appBlockId === operation.definition.appBlockId)
        return;
    ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: 'AppBlock definition replacement must keep appBlockId stable',
        path: ['definition', 'appBlockId'],
    });
});
exports.CustomAppBlockDefinitionOperationBatchSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    operations: zod_1.z.array(exports.CustomAppBlockDefinitionOperationSchema).min(1),
})
    .strict();
function defineCustomAppBlock(input) {
    return exports.CustomAppBlockDefinitionSchema.parse(input);
}
function buildAppBlockDefinitionBuildingBlockRefs(parsed) {
    const refs = [
        ...parsed.resources.map(resource => exports.CustomAppBuildingBlockRefSchema.parse({
            schemaVersion: exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.datasource.${resource.role}.${resource.contentModel}.${resource.sourceKey}`,
            kind: 'dataSource',
            family: 'streamlain.datasource',
            label: resource.label ?? resource.sourceKey,
            sourceKey: resource.sourceKey,
            metadata: {
                role: resource.role,
                contentModel: resource.contentModel,
                ...(resource.audience ? { audience: resource.audience } : {}),
                writable: resource.allowWrites === true,
            },
        })),
        ...parsed.commands.map(command => exports.CustomAppBuildingBlockRefSchema.parse({
            schemaVersion: exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.action.${command.type}.${command.id}`,
            kind: 'action',
            family: 'streamlain.action',
            label: command.label,
            actionId: command.id,
            sourceKey: command.type === 'rowInsert'
                ? command.sourceKey
                : command.type === 'attachmentUpdate'
                    ? command.sourceKey
                    : command.inputSourceKey,
            metadata: {
                intent: command.type,
            },
        })),
        ...parsed.agentActions.map(action => exports.CustomAppBuildingBlockRefSchema.parse({
            schemaVersion: exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.capability.agentAction.invoke.${action.id}`,
            kind: 'capability',
            family: 'streamlain.capability',
            label: action.displayName,
            capabilityId: 'agentAction.invoke',
            actionId: action.id,
        })),
        ...parsed.exports.map(documentExport => exports.CustomAppBuildingBlockRefSchema.parse({
            schemaVersion: exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.documentExport.${documentExport.formats.join('+')}.${documentExport.id}`,
            kind: 'documentExport',
            family: 'streamlain.documentExport',
            label: documentExport.label,
            exportId: documentExport.id,
            actionId: documentExport.targetActionId,
            metadata: {
                formats: [...documentExport.formats],
            },
        })),
        ...parsed.commands.flatMap(command => {
            if (command.type === 'rowInsert') {
                return [
                    exports.CustomAppBuildingBlockRefSchema.parse({
                        schemaVersion: exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION,
                        id: `streamlain.capability.database.row.insert.${command.id}`,
                        kind: 'capability',
                        family: 'streamlain.capability',
                        label: 'database.row.insert',
                        capabilityId: 'database.row.insert',
                        actionId: command.id,
                        sourceKey: command.sourceKey,
                    }),
                ];
            }
            if (command.type === 'attachmentUpdate') {
                return [
                    exports.CustomAppBuildingBlockRefSchema.parse({
                        schemaVersion: exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION,
                        id: `streamlain.capability.attachment.update.${command.id}`,
                        kind: 'capability',
                        family: 'streamlain.capability',
                        label: 'attachment.update',
                        capabilityId: 'attachment.update',
                        actionId: command.id,
                        sourceKey: command.sourceKey,
                    }),
                ];
            }
            return [
                exports.CustomAppBuildingBlockRefSchema.parse({
                    schemaVersion: exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION,
                    id: `streamlain.capability.automation.run.${command.id}`,
                    kind: 'capability',
                    family: 'streamlain.capability',
                    label: 'automation.run',
                    capabilityId: 'automation.run',
                    actionId: command.id,
                    sourceKey: command.inputSourceKey,
                }),
            ];
        }),
    ];
    const uniqueRefs = new Map();
    for (const ref of refs)
        uniqueRefs.set(ref.id, ref);
    return [...uniqueRefs.values()];
}
function compileCustomAppBlockDefinition(definition) {
    const parsed = exports.CustomAppBlockDefinitionSchema.parse(definition);
    const routes = parsed.routes.map(route => route.route);
    const dataSourceKeys = uniqueStrings([
        ...parsed.resources.map(resource => resource.sourceKey),
        ...routes.flatMap(route => route.dataSourceKeys),
    ]);
    const navigation = parsed.navigation.length > 0
        ? parsed.navigation
        : routes
            .filter(route => route.navigation)
            .map((route, index) => exports.CustomAppNavigationItemSchema.parse({
            id: `nav:${route.path}`,
            label: route.title,
            path: route.path,
            order: index,
        }));
    const buildingBlockRefs = new Map();
    for (const ref of [
        ...buildAppBlockDefinitionBuildingBlockRefs(parsed),
        ...parsed.routes.flatMap(route => route.buildingBlockRefs),
    ]) {
        buildingBlockRefs.set(ref.id, ref);
    }
    const generatedInteractionControlIds = uniqueStrings([
        ...routes.map(route => `route:${route.path}`),
        ...dataSourceKeys.map(sourceKey => `dataset:${sourceKey}`),
        ...parsed.commands.flatMap(action => [
            `action:${action.id}`,
            ...(action.type === 'automationRun' ? [`status:${action.id}`] : []),
            ...(action.type === 'rowInsert'
                ? action.fields.map(field => `action:${action.id}:field:${field.columnId}`)
                : []),
        ]),
        ...parsed.exports.map(documentExport => `export:${documentExport.id}`),
    ]);
    const routeModule = exports.CustomAppRouteModuleSchema.parse({
        schemaVersion: exports.CUSTOM_APP_ROUTE_MODULE_SCHEMA_VERSION,
        id: parsed.appBlockId,
        label: parsed.title,
        rootRoutePath: parsed.rootRoutePath,
        routePaths: routes.map(route => route.path),
        filePaths: uniqueStrings([
            ...routes
                .map(route => route.entry)
                .filter(entry => !isCustomAppNativeRouteEntry(entry)),
            ...parsed.routes.flatMap(route => route.filePaths),
            ...Object.keys(parsed.files),
        ]),
        dataSourceKeys,
        actionIds: parsed.commands.map(action => action.id),
        navigationItemIds: navigation.map(item => item.id),
        interactionControlIds: uniqueStrings(parsed.routes
            .flatMap(route => route.interactionControlIds)
            .concat(generatedInteractionControlIds)),
        buildingBlockRefs: [...buildingBlockRefs.values()],
        assetRefs: uniqueStrings(parsed.routes.flatMap(route => route.assetRefs)),
        shared: false,
    });
    return exports.CustomAppAppBlockDefinitionOutputSchema.parse({
        visibility: parsed.visibility,
        routes,
        navigation,
        resources: parsed.resources,
        dataSourceKeys,
        actions: parsed.commands,
        documentExports: parsed.exports,
        files: parsed.files,
        routeModules: [routeModule],
        routeSeo: buildAppBlockRouteSeoContracts(parsed),
    });
}
function normalizeCustomAppRoutePath(path) {
    if (path === '/')
        return '/';
    const normalized = `/${path.replace(/^\/+/, '').replace(/\/+$/, '')}`;
    return normalized === '//' ? '/' : normalized;
}
function joinCustomAppRoutePath(prefix, suffix) {
    const normalizedPrefix = normalizeCustomAppRoutePath(prefix);
    const normalizedSuffix = normalizeCustomAppRoutePath(suffix);
    if (normalizedSuffix === '/')
        return normalizedPrefix;
    if (normalizedPrefix === '/')
        return normalizedSuffix;
    return `${normalizedPrefix}/${normalizedSuffix.replace(/^\/+/, '')}`;
}
function remapMountedRoutePath(input) {
    const routePath = normalizeCustomAppRoutePath(input.routePath);
    const templateRoot = normalizeCustomAppRoutePath(input.templateRootRoutePath);
    const mountPrefix = normalizeCustomAppRoutePath(input.mountRoutePrefix);
    if (routePath === templateRoot)
        return mountPrefix;
    const templatePrefix = templateRoot === '/' ? '' : templateRoot;
    if (templatePrefix && routePath.startsWith(`${templatePrefix}/`)) {
        return joinCustomAppRoutePath(mountPrefix, routePath.slice(templatePrefix.length));
    }
    return joinCustomAppRoutePath(mountPrefix, routePath);
}
function scopedAppBlockId(mountId, id) {
    return id.startsWith(`${mountId}:`) ? id : `${mountId}:${id}`;
}
function isCustomAppNativeRouteEntry(path) {
    return path.startsWith('streamlain:');
}
function scopedAppBlockFilePath(mountId, path) {
    if (isCustomAppNativeRouteEntry(path))
        return path;
    if (path.startsWith(`${mountId}/`))
        return path;
    return `${mountId}/${path.replace(/^\/+/, '')}`;
}
function scopedAppBlockRouteModuleId(input) {
    if (input.routeModule.id === input.definition.appBlockId ||
        normalizeCustomAppRoutePath(input.routeModule.rootRoutePath) ===
            normalizeCustomAppRoutePath(input.definition.rootRoutePath)) {
        return input.mount.mountId;
    }
    return scopedAppBlockId(input.mount.mountId, input.routeModule.id);
}
function mapCustomAppActionDataSources(action, mapSourceKey, mapActionId) {
    if (action.type === 'rowInsert') {
        return {
            ...action,
            sourceKey: mapSourceKey(action.sourceKey),
        };
    }
    if (action.type === 'attachmentUpdate') {
        return {
            ...action,
            sourceKey: mapSourceKey(action.sourceKey),
        };
    }
    return {
        ...action,
        inputSourceKey: action.inputSourceKey
            ? mapSourceKey(action.inputSourceKey)
            : action.inputSourceKey,
        inputBindings: action.inputBindings.map(binding => ({
            ...binding,
            sourceKey: binding.sourceKey
                ? mapSourceKey(binding.sourceKey)
                : binding.sourceKey,
        })),
        resultPresentation: {
            ...action.resultPresentation,
            sourceKey: action.resultPresentation.sourceKey
                ? mapSourceKey(action.resultPresentation.sourceKey)
                : action.resultPresentation.sourceKey,
            filterSourceKey: action.resultPresentation.filterSourceKey
                ? mapSourceKey(action.resultPresentation.filterSourceKey)
                : action.resultPresentation.filterSourceKey,
            saveActionId: action.resultPresentation.saveActionId
                ? mapActionId(action.resultPresentation.saveActionId)
                : action.resultPresentation.saveActionId,
        },
    };
}
function mapCustomAppInteractionControlId(controlId, input) {
    if (controlId.startsWith('route:')) {
        return `route:${input.mapRoutePath(controlId.slice('route:'.length))}`;
    }
    if (controlId.startsWith('dataset:')) {
        return `dataset:${input.mapSourceKey(controlId.slice('dataset:'.length))}`;
    }
    if (controlId.startsWith('status:')) {
        return `status:${input.mapActionId(controlId.slice('status:'.length))}`;
    }
    if (controlId.startsWith('export:')) {
        return `export:${input.mapExportId(controlId.slice('export:'.length))}`;
    }
    if (controlId.startsWith('action:')) {
        const [, actionId, ...rest] = controlId.split(':');
        if (!actionId)
            return input.mapFallbackId(controlId);
        return ['action', input.mapActionId(actionId), ...rest].join(':');
    }
    return input.mapFallbackId(controlId);
}
function mapCustomAppTemplateTextMarkers(text, input) {
    if (text === undefined)
        return text;
    let mapped = text;
    for (const sourceKey of input.sourceKeys) {
        mapped = mapped
            .split(`data-sl-source="${sourceKey}"`)
            .join(`data-sl-source="${input.mapSourceKey(sourceKey)}"`);
    }
    for (const action of input.actions) {
        const mappedActionId = input.mapActionId(action.id);
        mapped = mapped
            .split(`data-sl-action="${action.id}"`)
            .join(`data-sl-action="${mappedActionId}"`)
            .split(`data-sl-control="action:${action.id}"`)
            .join(`data-sl-control="action:${mappedActionId}"`);
        if (action.type === 'rowInsert') {
            for (const field of action.fields) {
                mapped = mapped
                    .split(`data-sl-control="action:${action.id}:field:${field.columnId}"`)
                    .join(`data-sl-control="action:${mappedActionId}:field:${field.columnId}"`);
            }
        }
    }
    for (const documentExport of input.documentExports) {
        const mappedExportId = input.mapExportId(documentExport.id);
        mapped = mapped
            .split(`data-sl-export="${documentExport.id}"`)
            .join(`data-sl-export="${mappedExportId}"`)
            .split(`data-sl-control="export:${documentExport.id}"`)
            .join(`data-sl-control="export:${mappedExportId}"`);
    }
    return mapped;
}
const SHA256_ROUND_CONSTANTS = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1,
    0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786,
    0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
    0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b,
    0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a,
    0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
];
function rightRotate(value, bits) {
    return (value >>> bits) | (value << (32 - bits));
}
function customAppSha256Hex(text) {
    const bytes = new TextEncoder().encode(text);
    const bitLength = bytes.length * 8;
    const paddedLength = Math.ceil((bytes.length + 9) / 64) * 64;
    const padded = new Uint8Array(paddedLength);
    padded.set(bytes);
    padded[bytes.length] = 0x80;
    const view = new DataView(padded.buffer);
    view.setUint32(paddedLength - 8, Math.floor(bitLength / 0x100000000));
    view.setUint32(paddedLength - 4, bitLength);
    let h0 = 0x6a09e667;
    let h1 = 0xbb67ae85;
    let h2 = 0x3c6ef372;
    let h3 = 0xa54ff53a;
    let h4 = 0x510e527f;
    let h5 = 0x9b05688c;
    let h6 = 0x1f83d9ab;
    let h7 = 0x5be0cd19;
    const words = new Uint32Array(64);
    for (let offset = 0; offset < paddedLength; offset += 64) {
        for (let i = 0; i < 16; i++) {
            words[i] = view.getUint32(offset + i * 4);
        }
        for (let i = 16; i < 64; i++) {
            const s0 = rightRotate(words[i - 15], 7) ^
                rightRotate(words[i - 15], 18) ^
                (words[i - 15] >>> 3);
            const s1 = rightRotate(words[i - 2], 17) ^
                rightRotate(words[i - 2], 19) ^
                (words[i - 2] >>> 10);
            words[i] = (words[i - 16] + s0 + words[i - 7] + s1) >>> 0;
        }
        let a = h0;
        let b = h1;
        let c = h2;
        let d = h3;
        let e = h4;
        let f = h5;
        let g = h6;
        let h = h7;
        for (let i = 0; i < 64; i++) {
            const s1 = rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25);
            const ch = (e & f) ^ (~e & g);
            const temp1 = (h + s1 + ch + SHA256_ROUND_CONSTANTS[i] + words[i]) >>> 0;
            const s0 = rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22);
            const maj = (a & b) ^ (a & c) ^ (b & c);
            const temp2 = (s0 + maj) >>> 0;
            h = g;
            g = f;
            f = e;
            e = (d + temp1) >>> 0;
            d = c;
            c = b;
            b = a;
            a = (temp1 + temp2) >>> 0;
        }
        h0 = (h0 + a) >>> 0;
        h1 = (h1 + b) >>> 0;
        h2 = (h2 + c) >>> 0;
        h3 = (h3 + d) >>> 0;
        h4 = (h4 + e) >>> 0;
        h5 = (h5 + f) >>> 0;
        h6 = (h6 + g) >>> 0;
        h7 = (h7 + h) >>> 0;
    }
    return [h0, h1, h2, h3, h4, h5, h6, h7]
        .map(value => value.toString(16).padStart(8, '0'))
        .join('');
}
function compileCustomAppBlockMount(input) {
    const definition = exports.CustomAppBlockDefinitionSchema.parse(input.definition);
    const mount = exports.CustomAppAppBlockMountSchema.parse(input.mount);
    const appLevelRoutePath = input.appLevelRoutePath
        ? normalizeCustomAppRoutePath(input.appLevelRoutePath)
        : null;
    if (mount.appBlockId !== definition.appBlockId) {
        throw new Error(`Custom app mount ${mount.mountId} references ${mount.appBlockId} but definition is ${definition.appBlockId}`);
    }
    const output = compileCustomAppBlockDefinition(definition);
    const mapRoutePath = (routePath) => remapMountedRoutePath({
        routePath,
        templateRootRoutePath: definition.rootRoutePath,
        mountRoutePrefix: mount.routePrefix,
    });
    const mapSourceKey = (sourceKey) => mount.bindings[sourceKey]?.targetSourceKey ?? sourceKey;
    const mapActionId = (actionId) => scopedAppBlockId(mount.mountId, actionId);
    const mapNavigationId = (navigationId) => scopedAppBlockId(mount.mountId, navigationId);
    const mapExportId = (exportId) => scopedAppBlockId(mount.mountId, exportId);
    const mapFilePath = (path) => scopedAppBlockFilePath(mount.mountId, path);
    const routes = output.routes.map(route => exports.CustomAppRouteSchema.parse({
        ...route,
        path: mapRoutePath(route.path),
        entry: mapFilePath(route.entry),
        dataSourceKeys: route.dataSourceKeys.map(mapSourceKey),
        dynamicSlugSourceKey: route.dynamicSlugSourceKey
            ? mapSourceKey(route.dynamicSlugSourceKey)
            : route.dynamicSlugSourceKey,
    }));
    const navigation = mount.navigation && mount.navigationPlacement !== 'hidden'
        ? output.navigation.map(item => exports.CustomAppNavigationItemSchema.parse({
            ...item,
            id: mapNavigationId(item.id),
            label: mount.navigationLabel ?? item.label,
            path: mapRoutePath(item.path),
        }))
        : [];
    const actions = output.actions.map(action => exports.CustomAppActionSchema.parse({
        ...mapCustomAppActionDataSources(action, mapSourceKey, mapActionId),
        id: mapActionId(action.id),
    }));
    const documentExports = output.documentExports.map(documentExport => exports.CustomAppDocumentExportSchema.parse({
        ...documentExport,
        id: mapExportId(documentExport.id),
        routePath: mapRoutePath(documentExport.routePath),
        targetActionId: documentExport.targetActionId
            ? mapActionId(documentExport.targetActionId)
            : documentExport.targetActionId,
    }));
    const resources = output.resources.map(resource => exports.CustomAppAppBlockResourceDefinitionSchema.parse({
        ...resource,
        sourceKey: mapSourceKey(resource.sourceKey),
    }));
    const files = Object.fromEntries(Object.entries(output.files).map(([, file]) => {
        const path = mapFilePath(file.path);
        const text = mapCustomAppTemplateTextMarkers(file.text, {
            sourceKeys: output.resources.map(resource => resource.sourceKey),
            mapSourceKey,
            actions: output.actions,
            documentExports: output.documentExports,
            mapActionId,
            mapExportId,
        });
        return [
            path,
            exports.CustomAppArtifactFileSchema.parse({
                ...file,
                path,
                ...(text !== undefined
                    ? {
                        text,
                        bytes: new TextEncoder().encode(text).byteLength,
                        sha256: customAppSha256Hex(text),
                    }
                    : {}),
            }),
        ];
    }));
    const routeModules = output.routeModules.map(routeModule => {
        const moduleRoutePaths = routeModule.routePaths.map(mapRoutePath);
        const mappedRefs = routeModule.buildingBlockRefs.map(ref => exports.CustomAppBuildingBlockRefSchema.parse({
            ...ref,
            id: scopedAppBlockId(mount.mountId, ref.id),
            sourceKey: ref.sourceKey ? mapSourceKey(ref.sourceKey) : ref.sourceKey,
            actionId: ref.actionId ? mapActionId(ref.actionId) : ref.actionId,
            exportId: ref.exportId ? mapExportId(ref.exportId) : ref.exportId,
            routePath: ref.routePath ? mapRoutePath(ref.routePath) : ref.routePath,
        }));
        const documentExportRefs = output.documentExports
            .filter(documentExport => routeModule.routePaths.includes(documentExport.routePath))
            .map(documentExport => exports.CustomAppBuildingBlockRefSchema.parse({
            schemaVersion: exports.CUSTOM_APP_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: scopedAppBlockId(mount.mountId, `streamlain.documentExport.${documentExport.formats.join('+')}.${documentExport.id}`),
            kind: 'documentExport',
            family: 'streamlain.documentExport',
            label: documentExport.label,
            exportId: mapExportId(documentExport.id),
            actionId: documentExport.targetActionId
                ? mapActionId(documentExport.targetActionId)
                : undefined,
            routePath: mapRoutePath(documentExport.routePath),
            metadata: {
                formats: [...documentExport.formats],
            },
        }));
        const buildingBlockRefs = [...mappedRefs];
        for (const ref of documentExportRefs) {
            if (buildingBlockRefs.some(existing => existing.exportId === ref.exportId)) {
                continue;
            }
            buildingBlockRefs.push(ref);
        }
        return exports.CustomAppRouteModuleSchema.parse({
            ...routeModule,
            id: scopedAppBlockRouteModuleId({ definition, mount, routeModule }),
            label: mount.navigationLabel ?? routeModule.label,
            rootRoutePath: mapRoutePath(routeModule.rootRoutePath),
            routePaths: moduleRoutePaths,
            filePaths: routeModule.filePaths.map(mapFilePath),
            dataSourceKeys: routeModule.dataSourceKeys.map(mapSourceKey),
            actionIds: routeModule.actionIds.map(mapActionId),
            navigationItemIds: mount.navigation && mount.navigationPlacement !== 'hidden'
                ? routeModule.navigationItemIds.map(mapNavigationId)
                : [],
            interactionControlIds: routeModule.interactionControlIds.map(controlId => mapCustomAppInteractionControlId(controlId, {
                mapRoutePath,
                mapSourceKey,
                mapActionId,
                mapExportId,
                mapFallbackId: id => scopedAppBlockId(mount.mountId, id),
            })),
            buildingBlockRefs,
            assetRefs: routeModule.assetRefs.map(mapFilePath),
            shared: false,
        });
    });
    const routeSeo = output.routes.map(route => {
        const routePath = mapRoutePath(route.path);
        return buildCompiledRouteSeo({
            id: `${mount.mountId}:${routePath}`,
            routePath,
            appLevel: routePath === appLevelRoutePath,
            owner: {
                kind: 'appBlock',
                mountId: mount.mountId,
                appBlockId: definition.appBlockId,
            },
            seo: definition.seo,
        });
    });
    return exports.CustomAppAppBlockCompiledOutputSchema.parse({
        mountId: mount.mountId,
        visibility: output.visibility,
        routes,
        navigation,
        resources,
        dataSourceKeys: output.dataSourceKeys.map(mapSourceKey),
        actions,
        documentExports,
        files,
        routeModules,
        routeSeo,
    });
}
function compileCustomAppCompositionAppBlockOutputs(input) {
    if (input.composition.mounts.length === 0)
        return [];
    const definitionsById = new Map((input.appBlockDefinitions ?? []).map(definition => {
        const parsed = exports.CustomAppBlockDefinitionSchema.parse(definition);
        return [parsed.appBlockId, parsed];
    }));
    return input.composition.mounts.map(mount => {
        const definition = definitionsById.get(mount.appBlockId);
        if (!definition) {
            throw new Error(`Custom app mount ${mount.mountId} references missing AppBlock definition ${mount.appBlockId}`);
        }
        return compileCustomAppBlockMount({
            definition,
            mount,
            appLevelRoutePath: input.composition.shell.rootRoutePath,
        });
    });
}
function buildAppBlockRouteSeoContracts(definition) {
    const appLevelRoutePath = normalizeCustomAppRoutePath(definition.rootRoutePath);
    return definition.routes.map(routeDefinition => {
        const route = routeDefinition.route;
        return buildCompiledRouteSeo({
            id: `${definition.appBlockId}:${route.path}`,
            routePath: route.path,
            appLevel: normalizeCustomAppRoutePath(route.path) === appLevelRoutePath,
            owner: {
                kind: 'appBlock',
                mountId: definition.appBlockId,
                appBlockId: definition.appBlockId,
            },
            seo: definition.seo,
        });
    });
}
exports.CustomAppArtifactSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_ARTIFACT_SCHEMA_VERSION),
    artifactId: zod_1.z.string().min(1),
    createdAt: zod_1.z.string().min(1),
    provenance: exports.CustomAppCompiledArtifactProvenanceSchema.optional(),
    manifest: exports.CustomAppManifestSchema,
    files: zod_1.z.record(zod_1.z.string().min(1), exports.CustomAppArtifactFileSchema),
    routeModules: zod_1.z.array(exports.CustomAppRouteModuleSchema).default([]),
})
    .strict();
const CUSTOM_APP_SHELL_INDEX_HTML = [
    '<!doctype html>',
    '<html lang="en">',
    `<head><meta charset="utf-8"><title>${brand_1.BRAND_DISPLAY_NAME} Custom App</title></head>`,
    '<body><div id="streamlain-custom-app-root"></div></body>',
    '</html>',
    '',
].join('\n');
const CUSTOM_APP_SHELL_INDEX_HTML_SHA256 = customAppSha256Hex(CUSTOM_APP_SHELL_INDEX_HTML);
function uniqueStrings(values) {
    return [...new Set(values)];
}
function assertUniqueBy(values, keyOf, label) {
    const seen = new Set();
    for (const value of values) {
        const key = keyOf(value);
        if (seen.has(key)) {
            throw new Error(`Duplicate custom app compiled ${label}: ${key}`);
        }
        seen.add(key);
    }
}
function routeSeoRobotsDirectives(input) {
    const directives = input.indexableByDefault
        ? ['index', 'follow']
        : ['noindex', 'nofollow'];
    if (input.aiSearch.robotsAiPolicy === 'noai')
        directives.push('noai');
    if (input.aiSearch.robotsAiPolicy === 'noimageai') {
        directives.push('noai', 'noimageai');
    }
    return [...new Set(directives)];
}
function buildCompiledRouteSeo(input) {
    return exports.CustomAppCompiledRouteSeoSchema.parse({
        schemaVersion: exports.CUSTOM_APP_COMPILED_ROUTE_SEO_SCHEMA_VERSION,
        id: input.id,
        routePath: input.routePath,
        appLevel: input.appLevel,
        owner: input.owner,
        strategy: input.seo.strategy,
        indexableByDefault: input.seo.indexableByDefault,
        metadataSource: input.seo.metadataSource,
        structuredDataTypes: input.seo.structuredDataTypes,
        canonical: input.seo.canonical,
        hreflang: input.seo.hreflang,
        aiSearch: input.seo.aiSearch,
        robotsDirectives: routeSeoRobotsDirectives({
            indexableByDefault: input.seo.indexableByDefault,
            aiSearch: input.seo.aiSearch,
        }),
    });
}
function withRequiredCustomAppDeliveryRoutePolicies(input) {
    const routePolicies = [...input.delivery.routePolicies];
    const ensurePolicy = (path, cacheClass) => {
        if (routePolicies.some(policy => policy.path === path && policy.cacheClass === cacheClass)) {
            return;
        }
        routePolicies.push({ path, cacheClass });
    };
    const actionDataSourceKeys = input.actions.flatMap(action => {
        if (action.type === 'rowInsert')
            return [action.sourceKey];
        if (action.type === 'attachmentUpdate')
            return [action.sourceKey];
        return [
            action.inputSourceKey,
            action.resultPresentation.sourceKey,
            action.resultPresentation.filterSourceKey,
        ].filter((value) => Boolean(value));
    });
    const usesCustomData = input.delivery.mode !== 'public_static' &&
        (input.dataSourceKeys.length > 0 ||
            input.routes.some(route => route.dataSourceKeys.length > 0) ||
            actionDataSourceKeys.length > 0);
    if (usesCustomData) {
        if (input.delivery.mode === 'internal_live') {
            ensurePolicy(exports.CUSTOM_APP_INTERNAL_LIVE_DATA_ROUTE, 'internalLiveData');
        }
        else {
            ensurePolicy(exports.CUSTOM_APP_EXTERNAL_DATA_ROUTE, 'customData');
        }
    }
    if (input.actions.length > 0) {
        if (input.delivery.mode === 'internal_live') {
            ensurePolicy(exports.CUSTOM_APP_INTERNAL_LIVE_COMMAND_ROUTE, 'internalLiveCommand');
        }
        else {
            ensurePolicy(exports.CUSTOM_APP_EXTERNAL_ACTION_ROUTE, 'customAction');
        }
    }
    if (input.delivery.liveData.enabled) {
        if (input.delivery.mode === 'internal_live') {
            ensurePolicy(exports.CUSTOM_APP_INTERNAL_LIVE_EVENTS_ROUTE, 'internalLiveEvents');
        }
        else {
            ensurePolicy(exports.CUSTOM_APP_EXTERNAL_EVENTS_ROUTE, 'customEvents');
        }
    }
    return exports.CustomAppDeliverySchema.parse({
        ...input.delivery,
        routePolicies,
    });
}
function buildShellSeoContract(exposure) {
    return exports.CustomAppBlockSeoContractSchema.parse(exposure.robotsIndex
        ? {
            schemaVersion: exports.CUSTOM_APP_BLOCK_SEO_CONTRACT_SCHEMA_VERSION,
            strategy: 'pageRoute',
            indexableByDefault: true,
            metadataSource: 'static',
            structuredDataTypes: ['WebPage'],
            canonical: 'auto',
            hreflang: 'appLocales',
            aiSearch: {
                llmsTxt: 'include',
                semanticSummary: 'optional',
                robotsAiPolicy: 'allow',
            },
        }
        : {
            schemaVersion: exports.CUSTOM_APP_BLOCK_SEO_CONTRACT_SCHEMA_VERSION,
            strategy: 'internalRoute',
            indexableByDefault: false,
            metadataSource: 'none',
            structuredDataTypes: [],
            canonical: 'disabled',
            hreflang: 'none',
            aiSearch: {
                llmsTxt: 'exclude',
                semanticSummary: 'none',
                robotsAiPolicy: 'noai',
            },
        });
}
exports.CustomAppBlockVisibilityCompatibilityIssueSchema = zod_1.z
    .object({
    mountId: zod_1.z.string().min(1),
    appBlockId: zod_1.z.string().min(1),
    exposureProfile: exports.CustomAppExposureProfileSchema,
    requirement: zod_1.z.string().min(1),
    message: zod_1.z.string().min(1),
})
    .strict();
function liveDataScopeIncludes(scopes, scope) {
    return scopes.includes(scope);
}
function impliedCapabilitiesForAppBlockOutput(output, hasAgentActions = false) {
    const capabilities = new Set();
    if (output.dataSourceKeys.length > 0 ||
        output.routes.some(route => route.dataSourceKeys.length > 0)) {
        capabilities.add('dataset.readWindow');
    }
    if (output.visibility.liveDataScopes.length > 0) {
        capabilities.add('dataset.subscribe');
    }
    for (const action of output.actions) {
        if (action.type === 'rowInsert')
            capabilities.add('database.row.insert');
        if (action.type === 'automationRun')
            capabilities.add('automation.run');
        if (action.type === 'attachmentUpdate')
            capabilities.add('attachment.update');
    }
    if (output.documentExports.length > 0)
        capabilities.add('document.export');
    if (hasAgentActions)
        capabilities.add('agentAction.invoke');
    return capabilities;
}
function getCustomAppBlockVisibilityCompatibilityIssues(input) {
    const composition = exports.CustomAppCompositionSchema.parse(input.composition);
    const profile = composition.shell.exposureProfile;
    const appKind = resolveCustomAppKindFromExposureProfile(profile);
    const outputs = compileCustomAppCompositionAppBlockOutputs({
        composition,
        appBlockDefinitions: input.appBlockDefinitions,
    });
    const portalEnabled = profile === 'memberPortal' ||
        outputs.some(output => output.routes.some(route => route.audience === 'portal'));
    const mountsById = new Map(composition.mounts.map(mount => [mount.mountId, mount]));
    const definitionsById = new Map((input.appBlockDefinitions ?? []).map(definition => {
        const parsed = exports.CustomAppBlockDefinitionSchema.parse(definition);
        return [parsed.appBlockId, parsed];
    }));
    const issues = [];
    const addIssue = (output, effectiveProfile, requirement, message) => {
        const mount = mountsById.get(output.mountId);
        issues.push(exports.CustomAppBlockVisibilityCompatibilityIssueSchema.parse({
            mountId: output.mountId,
            appBlockId: mount?.appBlockId ?? output.mountId,
            exposureProfile: effectiveProfile,
            requirement,
            message,
        }));
    };
    for (const output of outputs) {
        const visibility = output.visibility;
        const capabilityClass = visibility.capabilityClass;
        const effectiveProfile = exposureProfileForCustomAppBlockCapabilityClass(capabilityClass);
        const exposure = deriveCustomAppExposureProfile(effectiveProfile);
        if (!isCustomAppBlockCapabilityCompatible({
            appKind,
            capabilityClass,
            portalEnabled,
        })) {
            addIssue(output, effectiveProfile, 'capabilityClass', `AppBlock ${output.mountId} capability class ${capabilityClass} is not compatible with ${appKind} apps`);
        }
        if ((effectiveProfile === 'publicStatic' ||
            effectiveProfile === 'publicInteractive') &&
            !visibility.publicSafe) {
            addIssue(output, effectiveProfile, 'publicSafe', `AppBlock ${output.mountId} must declare publicSafe=true for ${effectiveProfile}`);
        }
        if (!exposure.requiresAuthenticatedViewer && visibility.requiresAuth) {
            addIssue(output, effectiveProfile, 'requiresAuth', `AppBlock ${output.mountId} requires authenticated viewers but ${effectiveProfile} is public`);
        }
        if (!exposure.allowsWrites && visibility.requiresWrite) {
            addIssue(output, effectiveProfile, 'requiresWrite', `AppBlock ${output.mountId} requires writes but ${effectiveProfile} is read-only`);
        }
        if (!exposure.requiresAuthenticatedViewer && visibility.requiresSecret) {
            addIssue(output, effectiveProfile, 'requiresSecret', `AppBlock ${output.mountId} exposes secret-bound operations in public profile ${effectiveProfile}`);
        }
        if (!exposure.allowsLiveData && visibility.liveDataScopes.length > 0) {
            addIssue(output, effectiveProfile, 'liveDataScopes', `AppBlock ${output.mountId} requires live data but ${effectiveProfile} forbids live data`);
        }
        const mount = mountsById.get(output.mountId);
        const impliedCapabilities = impliedCapabilitiesForAppBlockOutput(output, Boolean(mount && definitionsById.get(mount.appBlockId)?.agentActions.length));
        const resourcesBySourceKey = new Map(output.resources.map(resource => [resource.sourceKey, resource]));
        for (const capability of visibility.requiredCapabilities) {
            if (impliedCapabilities.has(capability))
                continue;
            addIssue(output, effectiveProfile, `requiredCapabilities.${capability}`, `AppBlock ${output.mountId} declares required capability ${capability} but its compiled output does not expose it`);
        }
        if (effectiveProfile === 'publicStatic') {
            for (const capability of impliedCapabilities) {
                const decision = decideCustomAppExposureCapability({
                    exposureProfile: effectiveProfile,
                    principal: 'anonymous',
                    capability,
                    actionAudience: 'public',
                    bindingAudience: 'public',
                });
                if (decision.allowed)
                    continue;
                addIssue(output, effectiveProfile, `publicStatic.${capability}`, `AppBlock ${output.mountId} capability ${capability} is not allowed in publicStatic`);
            }
        }
        if (effectiveProfile === 'publicInteractive') {
            for (const action of output.actions) {
                const capability = customAppCapabilityForAction(action);
                const decision = decideCustomAppExposureCapability({
                    exposureProfile: effectiveProfile,
                    principal: 'anonymous',
                    capability,
                    actionAudience: action.audience,
                    bindingAudience: customAppBindingAudienceForAction(action, resourcesBySourceKey),
                });
                if (action.type === 'rowInsert') {
                    if (!decision.allowed || !action.consentRequired) {
                        addIssue(output, effectiveProfile, `publicInteractive.action.${action.id}`, `AppBlock ${output.mountId} action ${action.id} requires authenticated or unsafe execution; publicInteractive rowInsert actions need consent`);
                    }
                    const targetResource = resourcesBySourceKey.get(action.sourceKey);
                    if (!targetResource?.allowWrites) {
                        addIssue(output, effectiveProfile, `publicInteractive.resource.${action.sourceKey}.allowWrites`, `AppBlock ${output.mountId} action ${action.id} targets resource ${action.sourceKey} without allowWrites=true`);
                    }
                    continue;
                }
                if (!decision.allowed) {
                    addIssue(output, effectiveProfile, `publicInteractive.action.${action.id}`, `AppBlock ${output.mountId} action ${action.id} requires authenticated or unsafe execution; publicInteractive actions need consent`);
                }
            }
        }
        if (effectiveProfile === 'memberPortal' ||
            effectiveProfile === 'internalLive') {
            for (const action of output.actions) {
                const decision = decideCustomAppExposureCapability({
                    exposureProfile: effectiveProfile,
                    principal: action.audience === 'portal' ? 'portal' : 'workspaceMember',
                    capability: customAppCapabilityForAction(action),
                    actionAudience: action.audience,
                    bindingAudience: customAppBindingAudienceForAction(action, resourcesBySourceKey),
                });
                if (decision.allowed)
                    continue;
                addIssue(output, effectiveProfile, `${effectiveProfile}.action.${action.id}`, `AppBlock ${output.mountId} action ${action.id} is not allowed for ${effectiveProfile}: ${decision.reason}`);
            }
        }
        if (effectiveProfile === 'internalLive' &&
            visibility.liveDataScopes.length > 0 &&
            !liveDataScopeIncludes(visibility.liveDataScopes, 'dataset-invalidations')) {
            addIssue(output, effectiveProfile, 'internalLive.liveDataScopes', `AppBlock ${output.mountId} internal live data must include dataset-invalidations`);
        }
    }
    return issues;
}
function customAppBindingAudienceForAction(action, resourcesBySourceKey) {
    if (action.type === 'automationRun')
        return action.audience;
    return resourcesBySourceKey.get(action.sourceKey)?.audience ?? 'internal';
}
function customAppCapabilityForAction(action) {
    switch (action.type) {
        case 'rowInsert':
            return 'database.row.insert';
        case 'automationRun':
            return 'automation.run';
        case 'attachmentUpdate':
            return 'attachment.update';
    }
}
function assertCustomAppBlockVisibilityCompatibility(input) {
    const issues = getCustomAppBlockVisibilityCompatibilityIssues(input);
    if (issues.length === 0)
        return;
    throw new Error(issues
        .map(issue => `${issue.mountId}/${issue.appBlockId}: ${issue.requirement}: ${issue.message}`)
        .join('; '));
}
function compileCustomAppComposition(input) {
    const composition = exports.CustomAppCompositionSchema.parse(input.composition);
    const appBlockOutputs = compileCustomAppCompositionAppBlockOutputs({
        composition,
        appBlockDefinitions: input.appBlockDefinitions,
    });
    const mountsById = new Map(composition.mounts.map(mount => [mount.mountId, mount]));
    for (const output of appBlockOutputs) {
        if (mountsById.has(output.mountId))
            continue;
        throw new Error(`Custom app compiled output references unknown mount ${output.mountId}`);
    }
    assertCustomAppBlockVisibilityCompatibility({
        composition,
        appBlockDefinitions: input.appBlockDefinitions,
    });
    const exposure = deriveCustomAppExposureProfile(composition.shell.exposureProfile);
    const shellRoute = exports.CustomAppRouteSchema.parse({
        path: composition.shell.rootRoutePath,
        title: composition.shell.name,
        entry: composition.shell.entry,
        dataSourceKeys: [],
        navigation: true,
        audience: exposure.routeAudience,
    });
    const shellNavigation = exports.CustomAppNavigationItemSchema.parse({
        id: 'home',
        label: composition.shell.name,
        path: shellRoute.path,
        order: 0,
    });
    const shellFile = exports.CustomAppArtifactFileSchema.parse({
        path: composition.shell.entry,
        contentType: 'text/html; charset=utf-8',
        sha256: CUSTOM_APP_SHELL_INDEX_HTML_SHA256,
        bytes: new TextEncoder().encode(CUSTOM_APP_SHELL_INDEX_HTML).byteLength,
        text: CUSTOM_APP_SHELL_INDEX_HTML,
    });
    const shellRouteModule = exports.CustomAppRouteModuleSchema.parse({
        schemaVersion: exports.CUSTOM_APP_ROUTE_MODULE_SCHEMA_VERSION,
        id: 'shell',
        label: composition.shell.name,
        rootRoutePath: shellRoute.path,
        routePaths: [shellRoute.path],
        filePaths: [shellFile.path],
        dataSourceKeys: [],
        actionIds: [],
        navigationItemIds: [shellNavigation.id],
        interactionControlIds: [`route:${shellRoute.path}`],
        buildingBlockRefs: [],
        assetRefs: [],
        shared: true,
    });
    const hasRootRouteMount = composition.mounts.some(mount => (mount.entryRoutePath ?? mount.routePrefix) ===
        composition.shell.rootRoutePath);
    const routes = [
        ...(hasRootRouteMount ? [] : [shellRoute]),
        ...appBlockOutputs.flatMap(output => output.routes),
    ];
    const manifestEntry = routes.find(route => route.path === composition.shell.rootRoutePath)
        ?.entry ?? composition.shell.entry;
    const navigation = [
        ...(hasRootRouteMount ? [] : [shellNavigation]),
        ...appBlockOutputs.flatMap(output => output.navigation),
    ];
    const actions = appBlockOutputs.flatMap(output => output.actions);
    const documentExports = appBlockOutputs.flatMap(output => output.documentExports);
    assertUniqueBy(routes, route => route.path, 'route path');
    assertUniqueBy(navigation, item => item.id, 'navigation id');
    assertUniqueBy(actions, action => action.id, 'action id');
    assertUniqueBy(documentExports, documentExport => documentExport.id, 'export id');
    const files = hasRootRouteMount
        ? {}
        : { [shellFile.path]: shellFile };
    for (const output of appBlockOutputs) {
        for (const [path, file] of Object.entries(output.files)) {
            if (files[path]) {
                throw new Error(`Duplicate custom app compiled file path: ${path}`);
            }
            files[path] = file;
        }
    }
    const routeModules = [
        ...(hasRootRouteMount ? [] : [shellRouteModule]),
        ...appBlockOutputs.flatMap(output => output.routeModules),
    ];
    assertUniqueBy(routeModules, routeModule => routeModule.id, 'route module id');
    const shellSeo = buildCompiledRouteSeo({
        id: 'shell:/',
        routePath: shellRoute.path,
        appLevel: true,
        owner: { kind: 'shell' },
        seo: buildShellSeoContract(exposure),
    });
    const routeSeo = [
        ...(hasRootRouteMount ? [] : [shellSeo]),
        ...appBlockOutputs.flatMap(output => output.routeSeo),
    ].map(item => {
        const route = routes.find(candidate => candidate.path === item.routePath);
        const mayBeIndexed = composition.shell.exposureProfile !== 'internalLive' &&
            route?.audience === 'public';
        return mayBeIndexed
            ? item
            : buildCompiledRouteSeo({
                id: item.id,
                routePath: item.routePath,
                appLevel: item.appLevel,
                owner: item.owner,
                seo: buildShellSeoContract(deriveCustomAppExposureProfile('internalLive')),
            });
    });
    assertUniqueBy(routeSeo, item => item.id, 'route SEO id');
    const dataSourceKeys = uniqueStrings([
        ...appBlockOutputs.flatMap(output => output.dataSourceKeys),
        ...routes.flatMap(route => route.dataSourceKeys),
        ...actions.flatMap(action => {
            if (action.type === 'rowInsert')
                return [action.sourceKey];
            if (action.type === 'attachmentUpdate')
                return [action.sourceKey];
            return [
                action.inputSourceKey,
                action.resultPresentation.sourceKey,
                action.resultPresentation.filterSourceKey,
            ].filter((value) => Boolean(value));
        }),
    ]);
    const definitionsById = new Map((input.appBlockDefinitions ?? []).map(definition => {
        const parsed = exports.CustomAppBlockDefinitionSchema.parse(definition);
        return [parsed.appBlockId, parsed];
    }));
    const agentActionCapabilities = appBlockOutputs
        .filter(output => {
        const mount = mountsById.get(output.mountId);
        return Boolean(mount && definitionsById.get(mount.appBlockId)?.agentActions.length);
    })
        .map(output => exports.CustomAppCapabilitySchema.parse({
        id: `agent-action:${output.mountId}:invoke`,
        capabilityId: 'agentAction.invoke',
        label: 'Invoke App Block Agent Actions',
        permission: 'execute',
        routePaths: output.routes.map(route => route.path),
        dataSourceKeys: output.dataSourceKeys,
        actionIds: [],
        quotaKey: 'custom_app.agent_action.invoke',
    }));
    const manifest = withCustomAppInteractionContract({
        schemaVersion: exports.CUSTOM_APP_MANIFEST_SCHEMA_VERSION,
        appId: composition.shell.appId,
        name: composition.shell.name,
        entry: manifestEntry,
        delivery: withRequiredCustomAppDeliveryRoutePolicies({
            delivery: exposure.delivery,
            dataSourceKeys,
            routes,
            actions,
        }),
        routes,
        navigation,
        dataSourceKeys,
        actions,
        capabilities: agentActionCapabilities,
        documentExports,
        routeSeo,
    });
    const compiledAt = input.now ?? new Date().toISOString();
    return exports.CustomAppArtifactSchema.parse({
        schemaVersion: exports.CUSTOM_APP_ARTIFACT_SCHEMA_VERSION,
        artifactId: input.artifactId ??
            `${composition.compositionId}-r${composition.revision}-compiled`,
        createdAt: compiledAt,
        provenance: {
            schemaVersion: exports.CUSTOM_APP_COMPILED_ARTIFACT_PROVENANCE_SCHEMA_VERSION,
            source: 'customAppComposition',
            compositionId: composition.compositionId,
            compositionRevision: composition.revision,
            compiledAt,
            compilerVersion: exports.CUSTOM_APP_COMPOSITION_COMPILER_VERSION,
        },
        manifest,
        files,
        routeModules,
    });
}
exports.CustomAppLifecycleBriefSchema = zod_1.z
    .object({
    prompt: zod_1.z.string().min(1).max(4000),
    goals: zod_1.z.array(zod_1.z.string().min(1).max(240)).max(16).default([]),
    updatedAt: zod_1.z.string().min(1),
    updatedByUserId: zod_1.z.string().min(1),
})
    .strict();
exports.CustomAppLifecycleRunStateSchema = zod_1.z
    .object({
    status: zod_1.z
        .enum([
        'idle',
        'plan-ready',
        'awaiting-confirmation',
        'applied',
        'failed',
    ])
        .default('idle'),
    lastPlanSummary: zod_1.z.string().max(2000).optional(),
    lastError: zod_1.z.string().max(2000).optional(),
    updatedAt: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.CustomAppLifecycleOperationSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    kind: zod_1.z.enum(['brief', 'composition', 'artifact', 'database']),
    status: zod_1.z.enum(['planned', 'applied', 'failed']),
    summary: zod_1.z.string().min(1).max(1000),
    createdAt: zod_1.z.string().min(1),
    updatedAt: zod_1.z.string().min(1),
    actorUserId: zod_1.z.string().min(1),
})
    .strict();
exports.CustomAppLifecycleBudgetCountersSchema = zod_1.z
    .object({
    routes: zod_1.z.number().int().nonnegative().default(0),
    navigationItems: zod_1.z.number().int().nonnegative().default(0),
    dataSources: zod_1.z.number().int().nonnegative().default(0),
    actions: zod_1.z.number().int().nonnegative().default(0),
    files: zod_1.z.number().int().nonnegative().default(0),
    artifactBytes: zod_1.z.number().int().nonnegative().default(0),
    updatedAt: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.CustomAppLifecycleSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_LIFECYCLE_SCHEMA_VERSION),
    brief: exports.CustomAppLifecycleBriefSchema.optional(),
    runState: exports.CustomAppLifecycleRunStateSchema.default({ status: 'idle' }),
    operations: zod_1.z.array(exports.CustomAppLifecycleOperationSchema).max(100).default([]),
    budgetCounters: exports.CustomAppLifecycleBudgetCountersSchema.default({}),
    confirmationRequired: zod_1.z.literal(true).default(true),
})
    .strict();
exports.CustomAppDatabaseBindingOwnershipSchema = zod_1.z.enum([
    'custom-app-owned',
    'attached-existing',
]);
exports.CustomAppDatabaseBindingStatusSchema = zod_1.z.enum([
    'active',
    'detached',
]);
exports.CustomAppDatabaseBindingDetachPolicySchema = zod_1.z.enum([
    'preserve-source',
]);
exports.CustomAppDatabaseBindingExposureSchema = zod_1.z
    .object({
    audience: exports.CustomAppDatabaseBindingAudienceSchema,
    materialized: zod_1.z.boolean().default(true),
    columnIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    rowLimit: zod_1.z.number().int().positive().max(5000).default(500),
    allowWrites: zod_1.z.boolean().default(false),
})
    .strict();
exports.CustomAppDatabaseBindingPlacementSchema = zod_1.z
    .object({
    docId: zod_1.z.string().min(1),
    blockId: zod_1.z.string().min(1),
})
    .strict();
exports.CustomAppDatabaseBindingSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_DATABASE_BINDING_SCHEMA_VERSION),
    sourceKey: zod_1.z.string().min(1),
    semanticKey: zod_1.z.string().min(1),
    role: zod_1.z.string().min(1),
    contentModel: zod_1.z.string().min(1),
    schemaFingerprint: zod_1.z.string().min(1),
    // Absent on legacy bindings: retain standard-role schema semantics.
    schemaAuthority: zod_1.z.enum(['standard', 'declared']).optional(),
    databaseId: zod_1.z.string().min(1),
    ownership: exports.CustomAppDatabaseBindingOwnershipSchema,
    status: exports.CustomAppDatabaseBindingStatusSchema.default('active'),
    label: zod_1.z.string().min(1),
    detachPolicy: exports.CustomAppDatabaseBindingDetachPolicySchema.default('preserve-source'),
    createdAt: zod_1.z.string().min(1),
    updatedAt: zod_1.z.string().min(1),
    revision: zod_1.z.number().int().nonnegative().default(1),
    grantedByUserId: zod_1.z.string().min(1).optional(),
    placement: exports.CustomAppDatabaseBindingPlacementSchema,
    originalPlacement: exports.CustomAppDatabaseBindingPlacementSchema,
    exposure: exports.CustomAppDatabaseBindingExposureSchema,
})
    .strict();
exports.CustomAppDatabaseBindingRegistrySchema = zod_1.z.record(zod_1.z.string().min(1), exports.CustomAppDatabaseBindingSchema);
exports.CUSTOM_APP_BUDGETS = {
    maxManifestBytes: 64 * 1024,
    maxFiles: 64,
    maxFileBytes: 512 * 1024,
    maxTotalBytes: 2 * 1024 * 1024,
    maxDatasetChunkBytes: 256 * 1024,
    maxDatasetChunks: 64,
    maxRoutes: 64,
    maxNavigationItems: 128,
    maxActions: 64,
    maxActionFields: 64,
    maxActionPayloadBytes: 64 * 1024,
    maxPublicActionsPerHour: 30,
    maxDataSources: 32,
    maxDatasetRows: 5000,
    defaultDatasetRows: 500,
};
function buildCustomAppInteractionContract(manifest) {
    const generatedControls = [
        ...manifest.routes.map(route => exports.CustomAppInteractionControlSchema.parse({
            id: `route:${route.path}`,
            label: route.title,
            kind: 'route',
            intent: 'navigate',
            routePath: route.path,
            requiredRole: 'reader',
        })),
        ...manifest.dataSourceKeys.map(sourceKey => exports.CustomAppInteractionControlSchema.parse({
            id: `dataset:${sourceKey}`,
            label: sourceKey,
            kind: 'dataset',
            intent: 'readDataset',
            sourceKey,
            requiredRole: 'reader',
        })),
        ...manifest.actions.flatMap(action => {
            const actionControl = exports.CustomAppInteractionControlSchema.parse({
                id: `action:${action.id}`,
                label: action.label,
                kind: 'action',
                intent: customAppActionIntent(action),
                actionId: action.id,
                sourceKey: action.type === 'rowInsert'
                    ? action.sourceKey
                    : action.type === 'attachmentUpdate'
                        ? action.sourceKey
                        : action.inputSourceKey,
                requiredRole: 'writer',
                confirmationPolicy: action.type === 'automationRun' ||
                    action.type === 'attachmentUpdate' ||
                    action.consentRequired
                    ? 'required'
                    : 'recommended',
            });
            const statusControl = action.type === 'automationRun'
                ? [
                    exports.CustomAppInteractionControlSchema.parse({
                        id: `status:${action.id}`,
                        label: `${action.label} status`,
                        kind: 'status',
                        intent: 'readStatus',
                        actionId: action.id,
                        requiredRole: 'reader',
                    }),
                ]
                : [];
            const fieldControls = action.type === 'rowInsert'
                ? action.fields.map(field => exports.CustomAppInteractionControlSchema.parse({
                    id: `action:${action.id}:field:${field.columnId}`,
                    label: field.label,
                    kind: 'field',
                    intent: 'editField',
                    actionId: action.id,
                    sourceKey: action.sourceKey,
                    fieldColumnId: field.columnId,
                    fieldType: field.type,
                    fieldRequired: field.required,
                    fieldOptions: field.options,
                    requiredRole: 'writer',
                }))
                : [];
            return [actionControl, ...statusControl, ...fieldControls];
        }),
        ...manifest.documentExports.map(documentExport => exports.CustomAppInteractionControlSchema.parse({
            id: `export:${documentExport.id}`,
            label: documentExport.label,
            kind: 'export',
            intent: 'exportDocument',
            routePath: documentExport.routePath,
            actionId: documentExport.targetActionId,
            exportId: documentExport.id,
            selector: documentExport.selector,
            formats: documentExport.formats,
            filenameTemplate: documentExport.filenameTemplate,
            requiredRole: documentExport.targetActionId ? 'writer' : 'reader',
            confirmationPolicy: documentExport.targetActionId
                ? 'recommended'
                : 'none',
        })),
    ];
    const controls = new Map();
    const generatedControlIds = new Set(generatedControls.map(control => control.id));
    for (const control of generatedControls)
        controls.set(control.id, control);
    for (const control of manifest.interaction?.controls ?? []) {
        if (generatedControlIds.has(control.id)) {
            continue;
        }
        if (isGeneratedCustomAppInteractionControlId(control.id)) {
            continue;
        }
        controls.set(control.id, exports.CustomAppInteractionControlSchema.parse(control));
    }
    return exports.CustomAppInteractionContractSchema.parse({
        schemaVersion: exports.CUSTOM_APP_INTERACTION_CONTRACT_SCHEMA_VERSION,
        protocol: 'streamlain-custom-app-bridge/v1',
        controls: [...controls.values()],
        runtimeHints: [
            'Use manifest-declared controls and platform actions; never infer privileged operations from hidden DOM state.',
            'Generated route, dataset, action, status, and field control IDs are rebuilt from the manifest; custom controls must use separate custom IDs.',
            'Generated export controls expose document export selectors/formats and optional attachment saveback actions through StreamLainCustomApp.exportElement/downloadExport/saveExport.',
            'Database attachment cells must be rendered through StreamLainCustomApp.resolveAttachmentUrl(cellOrFile, { sourceKey, rowId, columnId }); raw blob URLs are not part of the Custom-App contract.',
            'Generated capability declarations are the review and runtime source of truth for dataset reads, subscriptions, platform actions, App Block Agent Actions, automation runs, attachment updates, and document exports.',
            'Display route, data-source, action, automation, and attachment permission denials as disabled controls or user-safe status messages.',
            ...(manifest.interaction?.runtimeHints ?? []),
        ],
    });
}
function buildCustomAppCapabilityDeclarations(manifest) {
    const routePathsForSource = (sourceKey) => manifest.routes
        .filter(route => route.dataSourceKeys.includes(sourceKey))
        .map(route => route.path);
    const actionDataSourceKeys = manifest.actions.flatMap(action => {
        if (action.type === 'rowInsert')
            return [action.sourceKey];
        if (action.type === 'attachmentUpdate')
            return [action.sourceKey];
        return [
            action.inputSourceKey,
            action.resultPresentation.sourceKey,
            action.resultPresentation.filterSourceKey,
        ].filter((value) => Boolean(value));
    });
    const declaredDataSourceKeys = [
        ...new Set([
            ...manifest.dataSourceKeys,
            ...manifest.routes.flatMap(route => route.dataSourceKeys),
            ...actionDataSourceKeys,
        ]),
    ];
    const generated = [
        ...declaredDataSourceKeys.flatMap(sourceKey => {
            const routePaths = routePathsForSource(sourceKey);
            const readCapability = exports.CustomAppCapabilitySchema.parse({
                id: `dataset:${sourceKey}:readWindow`,
                capabilityId: 'dataset.readWindow',
                label: `Read ${sourceKey}`,
                permission: 'read',
                routePaths,
                dataSourceKeys: [sourceKey],
            });
            const subscribeCapability = manifest.delivery.liveData.enabled ||
                manifest.delivery.mode === 'internal_live'
                ? [
                    exports.CustomAppCapabilitySchema.parse({
                        id: `dataset:${sourceKey}:subscribe`,
                        capabilityId: 'dataset.subscribe',
                        label: `Subscribe to ${sourceKey}`,
                        permission: 'read',
                        routePaths,
                        dataSourceKeys: [sourceKey],
                    }),
                ]
                : [];
            return [readCapability, ...subscribeCapability];
        }),
        ...manifest.actions.map(action => {
            const capabilityId = action.type === 'rowInsert'
                ? 'database.row.insert'
                : action.type === 'automationRun'
                    ? 'automation.run'
                    : 'attachment.update';
            const dataSourceKeys = action.type === 'rowInsert' || action.type === 'attachmentUpdate'
                ? [action.sourceKey]
                : [
                    action.inputSourceKey,
                    action.resultPresentation.sourceKey,
                    action.resultPresentation.filterSourceKey,
                ].filter((value) => Boolean(value));
            return exports.CustomAppCapabilitySchema.parse({
                id: `action:${action.id}:${capabilityId}`,
                capabilityId,
                label: action.label,
                permission: 'execute',
                dataSourceKeys,
                actionIds: [action.id],
                quotaKey: action.type === 'automationRun'
                    ? 'custom_app.automation_run'
                    : 'custom_app.action',
            });
        }),
        ...manifest.documentExports.map(documentExport => exports.CustomAppCapabilitySchema.parse({
            id: `export:${documentExport.id}:document.export`,
            capabilityId: 'document.export',
            label: documentExport.label,
            permission: documentExport.targetActionId ? 'write' : 'read',
            routePaths: [documentExport.routePath],
            actionIds: documentExport.targetActionId
                ? [documentExport.targetActionId]
                : [],
        })),
    ];
    const merged = new Map();
    for (const capability of generated)
        merged.set(capability.id, capability);
    for (const capability of manifest.capabilities ?? []) {
        merged.set(capability.id, exports.CustomAppCapabilitySchema.parse(capability));
    }
    return [...merged.values()];
}
function isGeneratedCustomAppInteractionControlId(id) {
    return (id.startsWith('route:') ||
        id.startsWith('dataset:') ||
        id.startsWith('action:') ||
        id.startsWith('status:') ||
        id.startsWith('export:'));
}
function customAppActionIntent(action) {
    switch (action.type) {
        case 'rowInsert':
            return 'rowInsert';
        case 'automationRun':
            return 'automationRun';
        case 'attachmentUpdate':
            return 'saveAttachment';
    }
}
function withCustomAppInteractionContract(manifest) {
    const parsed = exports.CustomAppManifestSchema.parse(manifest);
    const capabilities = buildCustomAppCapabilityDeclarations(parsed);
    return exports.CustomAppManifestSchema.parse({
        ...parsed,
        capabilities,
        interaction: buildCustomAppInteractionContract(parsed),
    });
}
function createCustomAppDatabaseBinding(input) {
    const now = input.now ?? new Date().toISOString();
    const semanticKey = createCustomAppDatabaseSemanticKey(input);
    const schemaFingerprint = input.schemaFingerprint ??
        createCustomAppDatabaseSchemaFingerprint({
            role: input.role,
            contentModel: input.contentModel,
            columnIds: input.columnIds ?? [],
        });
    return exports.CustomAppDatabaseBindingSchema.parse({
        schemaVersion: exports.CUSTOM_APP_DATABASE_BINDING_SCHEMA_VERSION,
        sourceKey: input.sourceKey,
        semanticKey,
        role: input.role,
        contentModel: input.contentModel,
        schemaFingerprint,
        schemaAuthority: input.schemaAuthority,
        databaseId: input.databaseId,
        ownership: input.ownership,
        status: 'active',
        label: input.label,
        detachPolicy: 'preserve-source',
        createdAt: now,
        updatedAt: now,
        revision: 1,
        grantedByUserId: input.grantedByUserId,
        placement: { docId: input.docId, blockId: input.blockId },
        originalPlacement: { docId: input.docId, blockId: input.blockId },
        exposure: {
            audience: input.audience ?? 'internal',
            materialized: true,
            columnIds: input.columnIds ?? [],
            rowLimit: input.rowLimit ?? exports.CUSTOM_APP_BUDGETS.defaultDatasetRows,
            allowWrites: input.allowWrites ?? false,
        },
    });
}
function createCustomAppDatabaseSemanticKey(input) {
    const semanticKey = input.semanticKey?.trim() || input.sourceKey.trim();
    if (!semanticKey) {
        throw new Error('Custom App database semanticKey requires a sourceKey');
    }
    return semanticKey;
}
function createCustomAppDatabaseSchemaFingerprint(input) {
    const columns = input.columns
        ? input.columns.map(column => ({
            id: column.id,
            name: column.name ?? null,
            type: column.type ?? null,
            data: stableJsonValue(column.data ?? null),
        }))
        : (input.columnIds ?? []).map(id => ({
            id,
            name: null,
            type: null,
            data: null,
        }));
    const normalized = {
        version: 1,
        role: input.role,
        contentModel: input.contentModel,
        columns: columns.sort((a, b) => a.id.localeCompare(b.id)),
    };
    return `custom-app-db-schema:${stableJsonStringify(normalized)}`;
}
function stableJsonValue(value) {
    if (Array.isArray(value))
        return value.map(stableJsonValue);
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value)
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([key, nested]) => [key, stableJsonValue(nested)]));
    }
    return value;
}
function stableJsonStringify(value) {
    return JSON.stringify(stableJsonValue(value));
}
function bumpCustomAppDatabaseBindingRevision(binding, patch) {
    const { now, ...bindingPatch } = patch;
    return exports.CustomAppDatabaseBindingSchema.parse({
        ...binding,
        ...bindingPatch,
        updatedAt: now ?? new Date().toISOString(),
        revision: binding.revision + 1,
    });
}
